/* Lorelia Gestalter 9 (28.09.2026, Nachbesserung: Ebenen-Vorschau, Mini-Vorschauen, Lupe, Film, Prüfen) – Datei heißt weiter lr-gestalter8.js
   Lorelia Gestalter 8 (28.09.2026) – neue Bedienung: höchstens drei Schritte (Foto · Gestalten · Format),
   Designleiste oben im Schritt Gestalten, Übergänge beim Öffnen, zwischen Schritten und beim Warenkorb.
   Technik (teeinblue, Karten, Rahmen, Szenen) unverändert aus Gestalter 7.
   Lorelia Gestalter 7 (22.09.2026)
   Ersetzt Gestalter 2, 3D, 4, 5, 6 und die beiden Skripte im Custom-Liquid.
   Regeln: teeinblue-DOM nie umbauen (nur Textknoten übersetzen, echte Radios/Selects bedienen),
   Felder nie display:none, eigene Elemente außerhalb von .tee-form-wrapper.
   Leistung: EIN Beobachter (nur childList, gedrosselt), keine Dauer-Timer, Animation nur in sichtbarer Ansicht. */
(function(){
  'use strict';
  var D = document, H = D.documentElement;
  var BILD = window.LR_BILD || {};
  var WORT = window.LR7_WORT || 'Poster';
  var POSTER = H.classList.contains('lr-ist-poster');
  var HANDY = matchMedia('(max-width:749px)').matches;
  var RUHIG = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s, r){ return (r || D).querySelector(s); };
  var $$ = function(s, r){ return [].slice.call((r || D).querySelectorAll(s)); };
  var geld = function(c){ return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var norm = function(x){ return String(x).toLowerCase().replace(/[×x]/g, 'x').replace(/\s+/g, ''); };
  var camp = function(){ return $('.tee-campaign'); };
  /* Direkt-Einstieg (#gestalten): ruhige Ladefläche statt erst Produktseite, dann Sprung */
  if (/^#gestalten/.test(location.hash) && !RUHIG) {
    H.classList.add('lr8-laedt');
    var lade = $('.lr8-lade'); if (!lade) { lade = D.createElement('div'); lade.className = 'lr8-lade';
    var bildQ = (D.querySelector('meta[property="og:image"]') || {}).content || '';
    lade.innerHTML = '<div class="lr8-lade-in">' + (bildQ ? '<img alt="" src="' + bildQ.replace(/^http:/, 'https:') + (bildQ.indexOf('?') > 0 ? '&' : '?') + 'width=600">' : '') + '<p>Dein Gestalter öffnet sich …</p><i></i></div>';
    (D.body || D.documentElement).appendChild(lade); }
    setTimeout(function(){ ladeWeg(); }, 9000);
  }
  function ladeWeg(){
    var l = $('.lr8-lade'); H.classList.remove('lr8-laedt'); if (!l) return;
    l.classList.add('weg'); setTimeout(function(){ if (l.parentNode) l.parentNode.removeChild(l); }, 500);
  }
  var media = function(){ return $('.product-information__media'); };

  /* ================= Übersetzung (teeinblue + Kartendialog) ================= */
  var TEXT = {'personalize':'Gestalte dein ' + WORT,'personalise':'Gestalte dein ' + WORT,'personalize design':'Gestalte dein ' + WORT,'size':'Größe','color':'Farbe','colour':'Farbe','default':'Standard','preview':'Vorschau ansehen','add to cart':'In den Warenkorb','buy now':'Jetzt kaufen','quantity':'Anzahl','qty':'Anzahl','close':'Schließen','back':'Zurück','done':'Fertig','save':'Speichern','cancel':'Abbrechen','apply':'Übernehmen','loading...':'Wird geladen …','loading':'Wird geladen …','choose an option':'Bitte wählen','choose something...':'Bitte wählen','default template':'Standard','upload':'Hochladen','upload photo':'Foto hochladen','change photo':'Foto ändern','crop':'Zuschneiden','back to shopping':'Weiter einkaufen','this field is required':'Bitte ausfüllen','required':'Pflichtfeld','recustomize image':'Ausschnitt ändern','choose photo':'Foto auswählen','select photo':'Foto auswählen','upload image':'Foto hochladen','crop image':'Ausschnitt wählen','rotate':'Drehen','zoom':'Zoomen','confirm':'Übernehmen','ok':'OK','preview design':'Vorschau ansehen','your design':'Dein Design','select':'Übernehmen','select & continue':'Ort übernehmen','close preview':'Vorschau schließen','change image':'Foto ändern','choose an image':'Foto auswählen','search':'Suchen','choose another image':'Anderes Foto wählen','change':'Ändern','remove':'Entfernen'};
  var PH = {'pick a time':'Datum & Uhrzeit wählen','qty':'Anzahl','search':'Ort suchen','choose an option':'Bitte wählen','choose something...':'Bitte wählen'};
  function uebersetze(root){
    if (!root) return;
    var w = D.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var s = n.nodeValue.trim(); if (!s || s.length > 90) continue;
      var d = TEXT[s.toLowerCase()];
      if (d && s !== d) n.nodeValue = n.nodeValue.replace(s, d);
      else if (/^\d+\s*x\s*\d+\s*cm$/i.test(s)) n.nodeValue = n.nodeValue.replace(s, s.replace(/\s*x\s*/i, ' × '));
      else if (/\s-\s-?\d{1,3}\.\d{3,},\s*-?\d{1,3}\.\d{3,}$/.test(s)) n.nodeValue = s.replace(/\s-\s-?\d{1,3}\.\d{3,},\s*-?\d{1,3}\.\d{3,}$/, '');
    }
    $$('input[placeholder],textarea[placeholder]', root).forEach(function(i){ var d = PH[(i.placeholder || '').trim().toLowerCase()]; if (d) i.placeholder = d; });
  }
  function uebersetzeDialoge(){ $$('.vm--container, .tee-dialog').forEach(uebersetze); }

  /* ================= Preise ================= */
  var S = { reiter: 'produkt', aktiv: [], ab: null, preise: null, ausfPreis: null, kontext: '' };
  var produktJson = null;
  function handle(){ return (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0]; }
  function ladePreise(){
    var h = handle(); if (!h) return;
    fetch('/products/' + h + '.js').then(function(r){ return r.json(); }).then(function(p){
      produktJson = p;
      var istAusf = p.options && p.options[0] && /ausf/i.test(p.options[0].name || p.options[0]);
      var v = (p.variants || []).filter(function(x){ return x.available; });
      S.ab = v.length ? Math.min.apply(null, v.map(function(x){ return x.price; })) : null;
      S.preise = {}; S.ausfPreis = {};
      v.forEach(function(x){
        var a = istAusf ? x.option1 : '_';
        var g = norm(x.options[x.options.length - 1]);
        S.preise[a] = S.preise[a] || {};
        if (S.preise[a][g] == null || x.price < S.preise[a][g]) S.preise[a][g] = x.price;
        if (S.ausfPreis[a] == null || x.price < S.ausfPreis[a]) S.ausfPreis[a] = x.price;
      });
      var billig = v.filter(function(x){ return x.price === S.ab; })[0];
      S.kontext = billig ? ' · ' + (billig.options || []).filter(function(o){ return !/default|standard/i.test(o); }).join(' ').replace(/\s*\/\s*\d+\s*x\s*\d+\s*(?:"|″|in)?/gi, '').replace(/(\d)\s*x\s*(\d)/i, '$1 × $2') : '';
      takt();
    }).catch(function(){});
  }

  /* ================= Reiter-Logik (aus dem alten Custom-Liquid) ================= */
  var REITER = [
    {k:'foto', n:'Foto', t:'Dein Foto', u:'Lade dein Lieblingsfoto hoch – die Vorschau zeigt es sofort.'},
    {k:'gestalten', n:'Gestalten', t:'Gestalte dein ' + WORT, u:'Design wählen, eintippen – die Vorschau zeigt jede Eingabe sofort.'},
    {k:'produkt', n:'Format', t:'Dein Format', u: POSTER ? 'Rahmen und Größe – jede Wahl siehst du sofort an deinem Poster.' : 'Größe und Ausführung wählen.'},
    {k:'film', n:'Ansehen', t:'Dein ' + WORT + ' in Szene', u:'Einmal ansehen, wie es bei dir wirkt.'},
    {k:'pruefen', n:'Prüfen', t:'Passt alles?', u:'Bitte kurz prüfen – genau so wird gedruckt.'}
  ];
  var ZUSATZ = { film: 1, pruefen: 1 };
  /* Gruppen innerhalb von „Gestalten“ (nur zur Beschriftung) */
  var GRUPPE = { moment: 'Ort & Zeit', text: 'Eure Worte' };
  function reiterVon(f){ var g = gruppeVon(f); return g === 'foto' ? 'foto' : 'gestalten'; }
  function gruppeVon(f){
    var c = f.className || '';
    if (/tee-field--photo/.test(c)) return 'foto';
    if (/tee-field--star_maps|tee-field--maps|tee-field--date|tee-field--time/.test(c)) return 'moment';
    if (/tee-field--(template|clipart|grouped_clipart|image|color|option|variant)/.test(c)) return 'design';
    var titel = ((f.querySelector('.tee-field__heading') || {}).textContent || '').toLowerCase();
    if (/datum|uhrzeit|zeit|geboren|geburtsort|\bort\b|jahr|tag der/.test(titel)) return 'moment';
    if (f.querySelector('select, .tee-clipart, [class*=clipart], img')) return 'design';
    return 'text';
  }
  var sigAlt = '';
  var gesehen = (function(){
    try { return JSON.parse(sessionStorage.getItem('lr7-reiter-' + location.pathname) || '{}') || {}; }
    catch (e) { return {}; }
  })();
  function merkeReiter(){ try { sessionStorage.setItem('lr7-reiter-' + location.pathname, JSON.stringify(gesehen)); } catch (e) {} }
  function ordne(c){
    var felder = $$('.tee-field', c);
    felder.forEach(function(f){ if (!f.hasAttribute('data-lr-tab')) { f.setAttribute('data-lr-tab', reiterVon(f)); f.setAttribute('data-lr-gruppe', gruppeVon(f)); } });
    var zuletzt = null;
    felder.forEach(function(f){
      var g = f.getAttribute('data-lr-gruppe'), st = (g !== zuletzt && GRUPPE[g]) ? GRUPPE[g] : null;
      if ((f.getAttribute('data-lr-gruppe-start') || null) !== st) { if (st) f.setAttribute('data-lr-gruppe-start', st); else f.removeAttribute('data-lr-gruppe-start'); }
      if (getComputedStyle(f).display !== 'none') zuletzt = g;
    });
    $$('.tee-option--size, .tee-variants, .tee-form-actions, .tee-available-products, .tee-available-products .tee-field', c).forEach(function(o){ o.setAttribute('data-lr-tab', 'produkt'); });
    var alle = $$('[data-lr-tab]', c);
    /* Sichtbarkeit nur neu messen, wenn sich die Felder geändert haben (getComputedStyle ist teuer) */
    var sig = alle.map(function(e){ return e.getAttribute('data-lr-tab') + (e.className || ''); }).join('|');
    if (sig !== sigAlt) {
      sigAlt = sig;
      alle.forEach(function(e){ e.classList.remove('lr-weg'); });
      var da = {}; alle.forEach(function(e){ if (getComputedStyle(e).display !== 'none') da[e.getAttribute('data-lr-tab')] = true; });
      if ($('.lr7-designs [data-lr7-familie], .lr7-designs [data-lr-design]')) da.gestalten = true;
      da.produkt = true;
      /* Einmal vorhanden, immer sichtbar: teeinblue baut die Felder beim Vorlagen-
         wechsel kurz ab. Wurde in genau diesem Moment gemessen, verschwanden Reiter
         und kamen nie zurueck. Gemerkt wird je Produkt in der Sitzung. */
      Object.keys(da).forEach(function(k){ gesehen[k] = true; });
      S.aktiv = REITER.filter(function(r){ return gesehen[r.k] || (r.k === 'film' && POSTER) || r.k === 'pruefen'; });
    }
    merkeReiter();
    if (!S.aktiv.some(function(r){ return r.k === S.reiter; })) S.reiter = S.aktiv[0].k;
    alle.forEach(function(e){ var weg = e.getAttribute('data-lr-tab') !== S.reiter; if (e.classList.contains('lr-weg') !== weg) e.classList.toggle('lr-weg', weg); });
  }
  function baueSeite(c){
    var details = $('.product-details'); if (!details) return;
    c.classList.add('lr-kern');
    var halter = null;
    for (var e = c.parentElement; e && e !== details; e = e.parentElement) { e.classList.add('lr-kette'); if (e.parentElement === details) halter = e; }
    if (halter) halter.classList.add('lr-halter');
    var block = c.closest('.group-block-content > *') || halter;
    if (!$('.lr-start') && block) {
      var box = D.createElement('div'); box.className = 'lr-start';
      box.innerHTML = '<p class="lr-ab"><span data-lr-ab>ab …</span><small>inkl. MwSt.<span data-lr-kontext></span></small></p>' +
        '<button type="button" class="lr-los lr8-los" data-lr-auf><span>Jetzt gestalten</span><i aria-hidden="true">→</i></button>' +
        '<div class="lr-garantie"><span>Vorschau vor dem Kauf</span><span>Versand gratis</span><span>Sicher zahlen mit PayPal &amp; Klarna</span></div>';
      block.parentNode.insertBefore(box, block);
      var kl = D.createElement('div'); kl.className = 'lr-klebe';
      kl.innerHTML = '<b data-lr-ab>ab …</b><button type="button" class="lr-los" data-lr-auf>Jetzt gestalten</button>';
      D.body.appendChild(kl);
    }
    if (!$('.lr-gk-kopf')) {
      var kopf = D.createElement('div'); kopf.className = 'lr-gk lr-gk-kopf';
      kopf.innerHTML = '<span class="lr-logo">Lorelia</span><button type="button" data-lr-zu>✕ Schließen</button>';
      var reiter = D.createElement('div'); reiter.className = 'lr-gk lr-gk-reiter'; reiter.setAttribute('role', 'tablist');
      var fuss = D.createElement('div'); fuss.className = 'lr-gk lr-gk-fuss';
      fuss.innerHTML = '<button type="button" class="lr-zur" data-lr-zurueck aria-label="Zurück">←</button><div class="lr-summe">Dein ' + WORT + '<b data-lr-summe>…</b></div><button type="button" class="lr-los" data-lr-weiter>Weiter</button>';
      details.insertBefore(reiter, details.firstChild); details.insertBefore(kopf, details.firstChild); details.appendChild(fuss);
      var zu = D.createElement('button'); zu.type = 'button'; zu.className = 'lr-gk lr-gk-zu'; zu.setAttribute('data-lr-zu', ''); zu.setAttribute('aria-label', 'Gestalter schließen'); zu.textContent = '✕';
      D.body.appendChild(zu);
    }
  }
  function setzeText(e, t){ if (e && e.textContent !== t) e.textContent = t; }
  function zeichneKopf(){
    var c = camp(); if (!c) return;
    $$('[data-lr-ab]').forEach(function(e){ if (S.ab != null) setzeText(e, 'ab ' + geld(S.ab)); });
    var kx = $('[data-lr-kontext]'); if (kx && S.kontext) setzeText(kx, S.kontext);
    var nurFormat = S.aktiv.filter(function(x){ return !ZUSATZ[x.k]; }).length === 1;
    if (D.body.classList.contains('lr-nur-format') !== nurFormat) D.body.classList.toggle('lr-nur-format', nurFormat);
    $$('.lr-start [data-lr-auf], .lr-klebe [data-lr-auf]').forEach(function(b){ setzeText(b, nurFormat ? 'Größe wählen' : 'Jetzt gestalten'); });
    var r = $('.lr-gk-reiter');
    if (r && S.aktiv.length) {
      var i = S.aktiv.findIndex(function(x){ return x.k === S.reiter; });
      /* Welle 0: Der Foto-Schritt ist erst erledigt, wenn ein EIGENES Foto hochgeladen ist –
         vorher bekam er einen Haken, obwohl nur das Musterfoto im Poster lag. */
      var fotoOffen = S.aktiv.some(function(x){ return x.k === 'foto'; }) && !!fotoFehlt();
      var h = S.aktiv.map(function(x, n){ var fertig = n < i && !(x.k === 'foto' && fotoOffen); return '<button type="button" role="tab" data-lr-reiter="' + x.k + '" class="' + (x.k === S.reiter ? 'an ' : '') + (fertig ? 'fertig' : '') + '" aria-selected="' + (x.k === S.reiter) + '"><i class="lr8-balken"></i><span>' + x.n + '</span></button>'; }).join('');
      if (r.getAttribute('data-stand') !== h) { r.innerHTML = h; r.setAttribute('data-stand', h); }
      var naechst = S.aktiv[i + 1];
      var wk = $('[data-lr-weiter]'), letzt = i === S.aktiv.length - 1;
      if (!B.imKorb) setzeText(wk, letzt ? 'In den Warenkorb' + (S.summe ? ' · ' + S.summe : '') : naechst.k === 'film' ? 'Weiter: Ansehen' : naechst.k === 'pruefen' ? 'Weiter: Prüfen' : 'Weiter zu ' + naechst.n);
      if (wk) wk.classList.toggle('lr9-gesperrt', letzt && S.reiter === 'pruefen' && !bestaetigt());
      var pr = $('.lr8-schritt'); if (pr) setzeText(pr, 'Schritt ' + (i + 1) + ' von ' + S.aktiv.length);
      var z = $('[data-lr-zurueck]'); if (z) z.style.visibility = i > 0 ? 'visible' : 'hidden';
    }
    var alt = $('.lr-gk-hinweis.lr7-pflicht');
    if (alt && ((alt.getAttribute('data-art') === 'foto' && !fotoFehlt()) || (alt.getAttribute('data-art') !== 'foto' && !leerePflicht()))) alt.parentNode.removeChild(alt);
    var halter = $('.lr-halter');
    if (halter) {
      var info = S.aktiv.filter(function(x){ return x.k === S.reiter; })[0] || REITER[REITER.length - 1];
      var tt = halter.querySelector('.lr-gk-titel');
      if (!tt) { tt = D.createElement('h2'); tt.className = 'lr-gk-titel'; var uu = D.createElement('p'); uu.className = 'lr-gk-unter'; halter.insertBefore(uu, halter.firstChild); halter.insertBefore(tt, halter.firstChild); var sp = D.createElement('p'); sp.className = 'lr8-schritt'; halter.insertBefore(sp, halter.firstChild); }
      if (tt.textContent !== info.t) { tt.textContent = info.t; halter.querySelector('.lr-gk-unter').textContent = info.u; }
    }
  }
  function tabKlasse(){
    ['foto', 'gestalten', 'produkt', 'film', 'pruefen'].forEach(function(k){ var an = D.body.classList.contains('lr-gestalten') && S.reiter === k; if (D.body.classList.contains('lr-tab-' + k) !== an) D.body.classList.toggle('lr-tab-' + k, an); });
  }
  function wechsle(k){
    var vorher = S.aktiv.findIndex(function(x){ return x.k === S.reiter; }), nachher = S.aktiv.findIndex(function(x){ return x.k === k; });
    var zurueck = nachher < vorher;
    D.body.classList.toggle('lr8-zurueck', zurueck);
    if (S.reiter === 'film' && k !== 'film') filmStopp();
    if (k !== 'pruefen') siegel(false);
    S.reiter = k; var c = camp(); if (c) ordne(c); zeichneKopf(); tabKlasse(); designPanel(); produktPanel(); farbPanel(); groessenPanel(); pruefPanel();
    var k2 = $('.product-details > .lr-kette'); if (k2) k2.scrollTop = 0;
    D.body.classList.remove('lr-vorschau-klein');
    textZoom(null);
    if (k === 'produkt') { if (!B.rahmenGezeigt) { B.rahmenGezeigt = true; rahmenAuftritt(); } if (B.ansicht !== 'live' && B.ansicht !== 'wand' && B.ansicht !== 'groessen') zeige('live'); }
    else if (k === 'film') filmStart();
    else if (k === 'pruefen') { B.rahmenGewaehlt = true; if (B.ansicht !== 'live') zeige('live'); if (bestaetigt()) siegel(true); }
    else if (B.ansicht !== 'live') zeige('live');
    schrittUebergang(zurueck);
    B.zeichne();
  }
  function leerePflicht(){
    var c = camp(); if (!c) return null; var t = null;
    $$('.tee-field', c).forEach(function(f){
      var kopf = ((f.querySelector('.tee-field__heading') || {}).textContent || '').trim();
      if (t || /tee-field--photo/.test(f.className) || (getComputedStyle(f).display === 'none' && !f.classList.contains('lr-weg')) || !(f.querySelector('.tee-asterisk') || /\*$/.test(kopf))) return;
      var inp = f.querySelector('input:not([type=hidden]):not([type=radio]):not([type=checkbox]), textarea');
      if (inp && !String(inp.value || '').trim()) t = f;
    });
    return t;
  }
  /* Welle 0 (27.09.2026): Pflicht-Fotofeld ohne eigenes Foto? teeinblue zeigt dann
     .tee-photo-placeholder (Plus-Kachel); nach dem Hochladen .tee-photo-uploaded mit dem
     Kundenbild (customers/uploads). Nur bei klarem Beleg für "leer" melden – unbekannter
     Aufbau blockiert nie (sonst könnte niemand mehr kaufen). */
  function fotoFehlt(){
    var c = camp(); if (!c) return null; var t = null;
    $$('.tee-field--photo', c).forEach(function(f){
      if (t) return;
      if (getComputedStyle(f).display === 'none' && !f.classList.contains('lr-weg')) return;
      var kopf = ((f.querySelector('.tee-field__heading') || {}).textContent || '').trim();
      if (!(f.querySelector('.tee-asterisk') || /\*$/.test(kopf))) return;
      var eigen = f.querySelector('.tee-photo-uploaded, img[src*="/uploads/"], img[src^="blob:"]');
      if (!eigen && f.querySelector('.tee-photo-placeholder')) t = f;
    });
    return t;
  }
  function pflichtHinweis(art, text){
    var hw = $('.lr-gk-hinweis.lr7-pflicht');
    if (!hw) { hw = D.createElement('p'); hw.className = 'lr-gk-hinweis lr7-pflicht'; hw.setAttribute('role', 'alert'); var tt = $('.lr-gk-unter'); if (!tt) return; tt.parentNode.insertBefore(hw, tt.nextSibling); }
    hw.setAttribute('data-art', art); hw.textContent = text;
  }
  var FOTO_TEXT = 'Lade bitte noch dein eigenes Foto hoch – das Bild in der Vorschau ist nur ein Beispiel.';
  function oeffnen(start){
    var c = camp(); if (!c) return;
    var auf = function(){
      D.body.classList.add('lr-gestalten'); arbeite(true);
      wechsle(start && S.aktiv.some(function(x){ return x.k === start; }) ? start : (S.aktiv.length ? S.aktiv[0].k : 'produkt'));
      D.body.classList.remove('lr8-zurueck');
      setTimeout(ladeWeg, 250);
      setTimeout(function(){ B.zeichne(true); if (!enthuellen(B.designAnkunft ? 'design' : 'farbe')) setTimeout(function(){ enthuellen(B.designAnkunft ? 'design' : 'farbe'); }, 700); B.designAnkunft = false; }, B.designAnkunft ? 380 : 520);
      /* teeinblue setzt beim Aufbau manchmal den Fokus auf ein Kästchen weiter unten und scrollt die Bedienung dorthin.
         Solange der Kunde noch nichts angefasst hat: Fokus lösen, Bedienung wieder nach oben. */
      [350, 1200, 2600].forEach(function(t){ setTimeout(function(){
        if (B.angefasst) return;
        var a = D.activeElement; if (a && a.closest && a.closest('.tee-campaign')) a.blur();
        var k = $('.product-details > .lr-kette'); if (k) k.scrollTop = 0;
      }, t); });
    };
    /* Übergang: Produktbild gleitet in die Vorschau, die Bedienung schiebt sich von unten herein */
    var m = media(), d = $('.product-details');
    if (!RUHIG && typeof D.startViewTransition === 'function' && m && d && !D.body.classList.contains('lr-gestalten')) {
      m.style.viewTransitionName = 'lr8-bild'; d.style.viewTransitionName = 'lr8-blatt';
      D.documentElement.classList.add('lr8-vt');
      var vt = D.startViewTransition(auf);
      vt.finished.finally(function(){ m.style.viewTransitionName = ''; d.style.viewTransitionName = ''; D.documentElement.classList.remove('lr8-vt'); });
    } else {
      auf();
      if (!RUHIG) { D.body.classList.add('lr8-auf'); setTimeout(function(){ D.body.classList.remove('lr8-auf'); }, 900); }
    }
    if (location.hash !== '#gestalten') history.pushState({ lr: 1 }, '', location.pathname + location.search + '#gestalten');
    setTimeout(function(){ window.dispatchEvent(new Event('resize')); B.zeichne(); }, 60);
    var wartend = 0;
    (function vorhangWeg(){
      wartend++;
      if (B.uebernahme && wartend < 30) return setTimeout(vorhangWeg, 400);
      H.classList.remove('lr7-laedt');
      var v = $('.lr7-vorhang'); if (v) { v.classList.remove('an'); setTimeout(function(){ if (v.parentNode) v.parentNode.removeChild(v); }, 400); }
      try { sessionStorage.removeItem('lr7-wechsel'); } catch (x) {}
    })();
  }
  function schliessen(zurueck){
    D.body.classList.remove('lr-gestalten'); tabKlasse(); B.stopp();
    setTimeout(function(){ window.dispatchEvent(new Event('resize')); }, 60);
    if (zurueck && location.hash === '#gestalten') history.back();
  }
  D.addEventListener('click', function(e){
    if (!D.body.classList.contains('lr-gestalten') && camp() && e.target.closest('.product-information__media') && !e.target.closest('button, a, [role=button], .slider-button, slideshow-arrows')) { e.preventDefault(); e.stopPropagation(); return oeffnen(); }
    var b = e.target.closest('[data-lr-auf],[data-lr-zu],[data-lr-reiter],[data-lr-weiter],[data-lr-zurueck]'); if (!b) return;
    e.preventDefault();
    if (b.hasAttribute('data-lr-auf')) return oeffnen();
    if (b.hasAttribute('data-lr-zu')) return schliessen(true);
    if (b.hasAttribute('data-lr-reiter')) return wechsle(b.getAttribute('data-lr-reiter'));
    var i = S.aktiv.findIndex(function(x){ return x.k === S.reiter; });
    if (b.hasAttribute('data-lr-zurueck')) return wechsle(S.aktiv[Math.max(0, i - 1)].k);
    var naechst = S.aktiv[i + 1];
    /* Welle 0: ohne eigenes Foto nicht weiter. Gestalter 9: vor Film und Prüfen muss alles ausgefüllt sein */
    var ohneFoto = fotoFehlt();
    if (ohneFoto && (S.reiter === 'foto' || !naechst || ZUSATZ[naechst.k])) {
      if (S.reiter !== 'foto') wechsle('foto');
      pflichtHinweis('foto', FOTO_TEXT); return;
    }
    if (!naechst || (ZUSATZ[naechst.k] && !ZUSATZ[S.reiter])) {
      var leer = leerePflicht();
      if (leer) {
        wechsle(leer.getAttribute('data-lr-tab'));
        pflichtHinweis('feld', 'Bitte fülle noch „' + ((leer.querySelector('.tee-field__heading') || {}).textContent || 'dieses Feld').replace('*', '').trim() + '“ aus.');
        var inp = leer.querySelector('input,textarea'); if (inp) inp.focus(); return;
      }
    }
    if (naechst) return wechsle(naechst.k);
    if (S.aktiv.some(function(x){ return x.k === 'pruefen'; }) && !bestaetigt()) {
      var ok = $('.lr9-ok'); if (ok) { ok.classList.remove('lr9-wackel'); void ok.offsetWidth; ok.classList.add('lr9-wackel'); ok.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      return;
    }
    var atc = $('.tee-campaign .tee-btn--atc'); if (atc) { atc.click(); imKorb(); }
    var karte = $('[data-lr-karte]');
    if (karte && karte.checked && window.LR_KARTE) setTimeout(function(){ fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: window.LR_KARTE.id, quantity: 1 }] }) }).catch(function(){}); }, 1500);
  });
  D.addEventListener('click', function(e){
    if (!e.isTrusted || !e.target.closest || !e.target.closest('.tee-campaign .tee-btn--atc')) return;
    if (!fotoFehlt()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!D.body.classList.contains('lr-gestalten')) oeffnen('foto'); else wechsle('foto');
    pflichtHinweis('foto', FOTO_TEXT);
  }, true);
  var pulsT = 0;
  ['pointerdown', 'keydown', 'touchstart'].forEach(function(ev){ D.addEventListener(ev, function(e){ if (e.isTrusted && D.body.classList.contains('lr-gestalten')) B.angefasst = true; }, { capture: true, passive: true }); });
  D.addEventListener('input', function(e){
    if (RUHIG || !D.body.classList.contains('lr-gestalten') || !e.target.closest || !e.target.closest('.tee-campaign')) return;
    var m = media(); if (!m || Date.now() - pulsT < 380) return; pulsT = Date.now();
    m.classList.remove('lr8-puls'); void m.offsetWidth; m.classList.add('lr8-puls');
  }, true);
  /* Warenkorb: Poster fliegt zum Korb, Knopf bestätigt */
  function imKorb(){
    var knopf = $('[data-lr-weiter]'); if (!knopf) return;
    B.imKorb = true; knopf.classList.add('lr8-ok'); setzeText(knopf, '✓ Im Warenkorb');
    setTimeout(function(){ B.imKorb = false; knopf.classList.remove('lr8-ok'); zeichneKopf(); }, 2600);
    if (RUHIG) return;
    var quelle = $('.lr7-bild .lr7-rahmen') || $('.product-information__media img'), korb = $('a[href="/cart"], [href$="/cart"], .header-actions__cart-icon, cart-icon');
    if (!quelle || !korb) return;
    var a = quelle.getBoundingClientRect(), z = korb.getBoundingClientRect();
    if (!a.width || !z.width) return;
    var k = quelle.cloneNode(true); k.classList.add('lr8-flieger');
    k.style.cssText = 'position:fixed;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;margin:0;transform:none;z-index:6000;pointer-events:none';
    D.body.appendChild(k);
    var dx = z.left + z.width / 2 - (a.left + a.width / 2), dy = z.top + z.height / 2 - (a.top + a.height / 2), sk = Math.max(.06, 28 / a.width);
    k.animate([{ transform: 'none', opacity: 1 }, { transform: 'translate(' + dx * .45 + 'px,' + (dy * .45 - 80) + 'px) scale(' + (1 + sk) / 2.2 + ') rotate(-6deg)', opacity: 1, offset: .55 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sk + ') rotate(-10deg)', opacity: .2 }],
      { duration: 900, easing: 'cubic-bezier(.65,0,.35,1)' }).finished.then(function(){ k.remove(); korb.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.34,1.56,.64,1)' }); });
  }
  window.addEventListener('popstate', function(){
    if (location.hash !== '#gestalten' && D.body.classList.contains('lr-gestalten')) schliessen(false);
    if (location.hash === '#gestalten' && !D.body.classList.contains('lr-gestalten')) oeffnen();
  });
  D.addEventListener('keydown', function(e){ if (e.key === 'Escape' && D.body.classList.contains('lr-gestalten')) schliessen(true); });

  /* ================= Preise an den Größen + Summe ================= */
  var AUSF = { '359408': 'ohne', '359414': 'schwarz', '359415': 'weiss', '359416': 'walnuss', '359418': 'eiche', '360506': 'leinwand' };
  var RAHMEN = {
    ohne:    { name: 'kein Rahmen', info: 'Poster pur' },
    schwarz: { name: 'Schwarz', info: 'Holz, mattschwarz' },
    weiss:   { name: 'Weiß', info: 'Holz, weiß lackiert' },
    eiche:   { name: 'Eiche', info: 'Echtholz-Optik, hell' },
    walnuss: { name: 'Walnuss', info: 'Echtholz-Optik, dunkel' },
    leinwand:{ name: 'Leinwand', info: 'Auf Keilrahmen gespannt' }
  };
  function ausfuehrungen(){
    var c = camp(); if (!c) return [];
    return $$('.tee-available-products .tee-radio', c).map(function(r){
      var i = r.querySelector('input'), id = i ? String(i.value) : '';
      var l = r.querySelector('.tee-radio-label') || r;
      return { id: id, radio: r, aktiv: r.classList.contains('active'), titel: (l.textContent || '').replace(/\s+/g, ' ').trim(), schl: AUSF[id] || 'schwarz' };
    });
  }
  function preisTabelle(a){
    if (!S.preise) return null;
    var keys = Object.keys(S.preise);
    if (a) { var k = keys.filter(function(n){ return n.replace(/\s+/g, ' ').trim() === a.titel; })[0]; if (k) return S.preise[k]; }
    return S.preise['_'] || S.preise[keys[0]];
  }
  function pflegePreise(){
    var c = camp(); if (!c || !S.preise) return;
    var a = ausfuehrungen().filter(function(x){ return x.aktiv; })[0];
    var tab = preisTabelle(a) || {};
    $$('.tee-option--size .tee-radio-label', c).forEach(function(l){
      var s = l.querySelector('.lr-preis'); var t = (s ? l.textContent.replace(s.textContent, '') : l.textContent).trim();
      var p = tab[norm(t)]; if (p == null) return;
      if (!s) { s = D.createElement('span'); s.className = 'lr-preis'; l.appendChild(s); }
      setzeText(s, geld(p));
    });
    var akt = c.querySelector('.tee-option--size .tee-radio.active .lr-preis');
    var sm = $('[data-lr-summe]'); if (sm) setzeText(sm, akt ? akt.textContent : (S.ab != null ? 'ab ' + geld(S.ab) : '…'));
    S.summe = akt ? akt.textContent.trim() : '';
  }

  /* ================= Auswahl lesen: Format + Ausführung ================= */
  function format(){
    var c = camp(); var t = '';
    var g = c && c.querySelector('.tee-option--size .tee-radio.active'); if (g) t = g.textContent;
    var m = t.match(/(\d{2,3})\s*[x×]\s*(\d{2,3})/i);
    var a = m ? [+m[1], +m[2]] : [30, 40];
    return { b: Math.min(a[0], a[1]), h: Math.max(a[0], a[1]) };
  }
  function ausfuehrung(){
    var l = ausfuehrungen(), a = l.filter(function(x){ return x.aktiv; })[0];
    if (a) return a.schl;
    var n = (produktJson && produktJson.variants && produktJson.variants[0] && produktJson.variants[0].option1 || '').toLowerCase();
    if (/leinwand/.test(n)) return 'leinwand';
    if (/wei/.test(n)) return 'weiss'; if (/eiche/.test(n)) return 'eiche'; if (/walnuss/.test(n)) return 'walnuss';
    return 'schwarz';
  }

  /* ================= Poster-Kopie (per <use>, kostet nichts) ================= */
  function artwork(){
    var s = $$('.product-information__media .tee-mockup-artwork__wrapper svg[id^="tee-artwork-"]');
    return s[0] || $('svg[id^="tee-artwork-"]');
  }
  function posterSvg(){
    var a = artwork(); if (!a) return null;
    var vb = a.getAttribute('viewBox'); var w, h;
    if (vb) { var v = vb.split(/[\s,]+/); w = +v[2]; h = +v[3]; } else { w = a.width.baseVal.value || 300; h = a.height.baseVal.value || 400; }
    var ns = 'http://www.w3.org/2000/svg';
    var s = D.createElementNS(ns, 'svg'); s.setAttribute('viewBox', '0 0 ' + w + ' ' + h); s.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    var u = D.createElementNS(ns, 'use'); u.setAttribute('href', '#' + a.id); u.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + a.id); u.setAttribute('width', w); u.setAttribute('height', h);
    s.appendChild(u); return s;
  }

  /* ================= Projektion (Poster in Szenen) ================= */
  function adj(m){ return [m[4]*m[8]-m[5]*m[7], m[2]*m[7]-m[1]*m[8], m[1]*m[5]-m[2]*m[4], m[5]*m[6]-m[3]*m[8], m[0]*m[8]-m[2]*m[6], m[2]*m[3]-m[0]*m[5], m[3]*m[7]-m[4]*m[6], m[1]*m[6]-m[0]*m[7], m[0]*m[4]-m[1]*m[3]]; }
  function mm(a, b){ var c = []; for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) { var s = 0; for (var k = 0; k < 3; k++) s += a[3*i+k] * b[3*k+j]; c[3*i+j] = s; } return c; }
  function mv(m, v){ return [m[0]*v[0]+m[1]*v[1]+m[2]*v[2], m[3]*v[0]+m[4]*v[1]+m[5]*v[2], m[6]*v[0]+m[7]*v[1]+m[8]*v[2]]; }
  function basis(p){ var m = [p[0][0], p[1][0], p[2][0], p[0][1], p[1][1], p[2][1], 1, 1, 1]; var v = mv(adj(m), [p[3][0], p[3][1], 1]); return mm(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]); }
  /* Punkte immer in Reihenfolge oben-links, oben-rechts, unten-links, unten-rechts */
  function homographie(von, nach){ return mm(basis(nach), adj(basis(von))); }
  function proj(m, x, y){ var v = mv(m, [x, y, 1]); return [v[0] / v[2], v[1] / v[2]]; }
  function matrix3d(w, h, nach){
    var t = homographie([[0, 0], [w, 0], [0, h], [w, h]], nach);
    for (var i = 0; i < 9; i++) t[i] = t[i] / t[8];
    return 'matrix3d(' + [t[0], t[3], 0, t[6], t[1], t[4], 0, t[7], 0, 0, 1, 0, t[2], t[5], 0, t[8]].map(function(x){ return +x.toFixed(9); }).join(',') + ')';
  }

  /* Szenen: Bild 1024×1024, Papier-Viereck (ol, or, ur, ul) der Originalszene, dessen echte Größe (cm) und Anker.
     anker 'mitte' = Posterzentrum bleibt; 'boden' = Unterkante bleibt (steht/lehnt); 'fest' = Höhe bleibt (Nahaufnahme). */
  var SZENEN = {
    /* Wand: helles Sideboard-Zimmer. Maßstab aus dem Möbel (Sideboard 180 cm breit = 3,29 px je cm
       im 1024er-Bild). Das Viereck ist ein 60 × 80 großes Poster, mittig über dem Sideboard. */
    /* Wand: warmes Wohnzimmer mit Nussbaum-Sideboard (4,26 px je cm im 1024er-Bild),
       Poster mittig darüber, Unterkante 20 cm über der Ablage.
       Zoom 2.0: der sichtbare Wandausschnitt ist rund 120 cm breit – so wirkt auch ein
       30 × 40 wie ein Bild an der Wand und nicht wie eine Briefmarke (Lucas Hinweis 23.09.). */
    wand:     { name: 'Wand', art: 'bau', bild: BILD.s_wand3, bildHd: BILD.s_wand3_hd, licht: BILD.l_wand3, mini: BILD.m_wand3,
                quad: [[202,132],[458,132],[458,473],[202,473]], cm: [60, 80], anker: 'mitte', zoom: 2.0,
                schatten: [0.8, 1.5, 3.0, .34] },
    geschenk: { name: 'Geschenk', art: 'foto', bild: BILD.f_geschenk, bildHd: BILD.f_geschenk_hd, licht: BILD.li_geschenk, mini: BILD.fm_geschenk,
                quad: [[308.3,248.7],[676.1,303.9],[603.7,812.3],[200.9,749.0]], rahmen: 'Eiche', glanz: BILD.gl_geschenk, zoom: 1.0, weich: 0 },
    boden:    { name: 'Boden', art: 'foto', bild: BILD.f_boden, bildHd: BILD.f_boden_hd, licht: BILD.li_boden, mini: BILD.fm_boden,
                quad: [[439.2,180.1],[849.0,165.1],[813.2,854.7],[397.0,800.6]], rahmen: 'Schwarz', glanz: BILD.gl_boden, zoom: 1.0, weich: 0 },
    nah:      { name: 'Nah', art: 'foto', bild: BILD.f_nah, bildHd: BILD.f_nah_hd, licht: BILD.li_nah, mini: BILD.fm_nah,
                quad: [[265.5,139.0],[793.2,131.7],[771.0,866.7],[237.6,836.3]], rahmen: 'Weiß', glanz: BILD.gl_nah, zoom: 1.0, weich: 0 }
  };
  /* Größenvergleich: eigenes Zimmer mit Sofa (210 cm breit = 3,93 px je cm) */
  var GROESSEN_SZENE = { bild: BILD.s_sofa3, bildHd: BILD.s_sofa3_hd, licht: BILD.l_sofa3,
                         quad: [[404,59],[640,59],[640,373],[404,373]], cm: [60, 80], zoom: 1.5 };

  function bildFuer(Z, breite){
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    return (Z.bildHd && breite * dpr > 1150) ? Z.bildHd : Z.bild;
  }
  /* Sichtbares Blatt im Rahmen (merchOne-Druckflächen POSTER-37X27 und POSTER-57X37) */
  var SICHT = { '20x30': [17, 27], '30x40': [27, 37], '40x60': [37, 57], '60x80': [57, 77] };
  function masse(fm){
    var k = fm.b + 'x' + fm.h, si = SICHT[k] || [fm.b - 3, fm.h - 3];
    return { aussen: [fm.b, fm.h], papier: { b: si[0], h: si[1] }, leiste: (fm.b - si[0]) / 2 };
  }
  var LEISTE = 1.5;  /* sichtbare Rahmenleiste in cm (merchOne, flaches Profil) */
  var PX = 8;        /* Ebenen-Auflösung: Pixel pro cm */

  function rahmenEl(schl, fm, ppc){
    ppc = ppc || PX;
    var r = D.createElement('div');
    var ohneRahmen = schl === 'ohne' || schl === 'leinwand';
    r.className = 'lr7-rahmen lr7-rahmen--' + schl;
    var m = masse(fm), L = ohneRahmen ? 0 : m.leiste;
    /* Außenmaß ist das Format (z. B. 30 × 40), sichtbar bleibt das Blatt darin */
    r.style.width = ((m.papier.b + 2 * L) * ppc).toFixed(1) + 'px'; r.style.height = ((m.papier.h + 2 * L) * ppc).toFixed(1) + 'px';
    if (!ohneRahmen) { r.style.borderWidth = (L * ppc).toFixed(1) + 'px'; r.style.borderImageSource = 'url(' + BILD['r_' + schl] + ')'; }
    var p = D.createElement('div'); p.className = 'lr7-papier';
    var sv = schichtenSvg() || posterSvg(); if (sv) p.appendChild(sv);
    r.appendChild(p);
    return r;
  }

  /* Rahmen- und Szenenbilder vorladen; Border-Images werden sonst erst beim nächsten Zeichnen sichtbar */
  var vorgeladen = false;
  function vorladen(){
    if (vorgeladen || !POSTER) return; vorgeladen = true;
    /* Rahmenbilder sofort – ohne sie zeichnet der Rahmen leer. */
    ['r_schwarz', 'r_weiss', 'r_eiche', 'r_walnuss', 's_wand3', 'l_wand3'].forEach(function(k){
      if (!BILD[k]) return; var i = new Image(); i.onload = function(){ setTimeout(function(){ B.zeichne(true); }, 30); }; i.src = BILD[k];
    });
    /* Alle uebrigen Szenenfotos still hinterher. Wer spaeter auf Geschenk, Boden oder
       Nah tippt, hat das Zimmer dann schon im Zwischenspeicher – sonst erscheint erst
       das nackte Poster und das Foto kommt hinterher (Lucas Punkt 5). */
    var spaeter = ['f_geschenk', 'li_geschenk', 'gl_geschenk', 'f_boden', 'li_boden', 'gl_boden',
                   'f_nah', 'li_nah', 'gl_nah', 's_sofa3', 'l_sofa3'];
    /* Auf grossen Bildschirmen zeichnet bildFuer() die HD-Fassungen. Werden nur die
       kleinen vorgewaermt, haengt genau die Ansicht, die der Kunde anklickt – bei
       "Groessen" waren das gemessene 1,1 s. Also dieselbe Wahl vorab treffen. */
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    if ((media() ? media().clientWidth : 700) * dpr > 1150) {
      spaeter = spaeter.concat(['s_wand3_hd', 'f_geschenk_hd', 'f_boden_hd', 'f_nah_hd', 's_sofa3_hd']);
    }
    function schub(){ spaeter.forEach(function(k){ if (BILD[k]) { var i = new Image(); i.decoding = 'async'; i.src = BILD[k]; } }); }
    ('requestIdleCallback' in window) ? requestIdleCallback(schub, { timeout: 3000 }) : setTimeout(schub, 1500);
  }

  /* Ruft zurueck, sobald das Hintergrundfoto einer Ebene steht – spaetestens nach 700 ms,
     damit ein hakendes Bild die Ansicht niemals blockiert. */
  function wennBildDa(el, fertig){
    var i = el.querySelector('.lr7-szene__bild');
    if (!i || (i.complete && i.naturalWidth > 0)) { fertig(); return; }
    var einmal = false, los = function(){ if (einmal) return; einmal = true; fertig(); };
    i.addEventListener('load', los, { once: true });
    i.addEventListener('error', los, { once: true });
    setTimeout(los, 1200);
  }

  /* ================= Bühne ================= */
  var B = { ansicht: 'live', raf: 0, rahmenGezeigt: false, winkel: -24, kipp: -6, auto: true, zuletzt: 0 };
  var buehne = null;
  function bauen(){
    var m = media(); if (!m || !POSTER) return null;
    if (buehne && buehne.isConnected) return buehne;
    vorladen();
    buehne = D.createElement('div'); buehne.className = 'lr7';
    buehne.innerHTML = '<div class="lr7-bild"></div>' +
      '<button type="button" class="lr9-lupe-knopf" aria-label="Poster im Detail ansehen"><i aria-hidden="true"></i>Details</button>' +
      '<div class="lr7-unten"><p class="lr7-info"></p><div class="lr7-leiste" role="tablist" aria-label="Ansichten"></div></div>';
    buehne.querySelector('.lr9-lupe-knopf').addEventListener('click', function(e){ e.stopPropagation(); lupeAuf(); });
    var l = buehne.querySelector('.lr7-leiste');
    var knoepfe = [['live', 'Live', ''], ['wand', 'Wand', BILD.m_wand3], ['geschenk', 'Geschenk', BILD.fm_geschenk], ['boden', 'Boden', BILD.fm_boden], ['nah', 'Nah', BILD.fm_nah], ['dreh', '360°', ''], ['groessen', 'Größen', BILD.m_sofa3]];
    l.innerHTML = knoepfe.map(function(k){ return '<button type="button" role="tab" data-lr7-ansicht="' + k[0] + '"' + (k[2] ? ' style="background-image:url(' + k[2] + ')"' : '') + '><span>' + k[1] + '</span></button>'; }).join('');
    l.addEventListener('click', function(e){ var b = e.target.closest('[data-lr7-ansicht]'); if (b) zeige(b.getAttribute('data-lr7-ansicht')); });
    /* Wischen zwischen Ansichten (nicht im 360°) */
    var x0 = null, y0 = null;
    buehne.querySelector('.lr7-bild').addEventListener('pointerdown', function(e){ if (B.ansicht === 'dreh') return; x0 = e.clientX; y0 = e.clientY; });
    buehne.querySelector('.lr7-bild').addEventListener('pointerup', function(e){
      if (x0 == null) return; var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8 && B.ansicht === 'live' && !F && e.target.closest('.lr7-rahmen')) return lupeAuf();
      if (Math.abs(dx) < 45 || Math.abs(dy) > Math.abs(dx)) return;
      var liste = knoepfe.map(function(k){ return k[0]; }), i = liste.indexOf(B.ansicht);
      zeige(liste[(i + (dx < 0 ? 1 : liste.length - 1)) % liste.length]);
    });
    m.appendChild(buehne);
    return buehne;
  }
  function zeige(a){
    B.ansicht = a;
    var b = bauen(); if (!b) return;
    $$('.lr7-leiste button', b).forEach(function(x){ var an = x.getAttribute('data-lr7-ansicht') === a; x.classList.toggle('an', an); x.setAttribute('aria-selected', an); });
    b.setAttribute('data-ansicht', a);
    B.zeichne(true);
  }
  function stageMass(){
    var r = buehne.querySelector('.lr7-bild').getBoundingClientRect();
    return { w: r.width || 360, h: r.height || 360 };
  }
  var zeichenStand = '';
  B.zeichne = function(neu){
    if (!POSTER || !D.body.classList.contains('lr-gestalten')) return;
    var b = bauen(); if (!b) return;
    var fm = format(), au = ausfuehrung(), a = B.ansicht;
    var rahmenSichtbar = D.body.classList.contains('lr-tab-produkt') || D.body.classList.contains('lr-tab-pruefen') || D.body.classList.contains('lr-tab-film') || B.rahmenGewaehlt;
    var st = stageMass();
    var stand = [a, fm.b, fm.h, au, rahmenSichtbar, Math.round(st.w), Math.round(st.h), ebenenSig(artwork())].join('|');
    if (!neu && stand === zeichenStand) return;
    zeichenStand = stand;
    var feld = b.querySelector('.lr7-bild');
    cancelAnimationFrame(B.raf);
    var alt = feld.lastElementChild;
    /* Live: wechselt nur der Rahmen, wird das Materialbild getauscht statt alles neu gebaut.
       Sonst reißt teeinblue bei jedem Rahmenklick die ganze Vorschau ab (Lucas „hakt"). */
    if (a === 'live' && alt && alt._lr7live && alt.getAttribute('data-art') === 'live' &&
        Math.abs(alt._lr7live.st.w - st.w) < 2 && Math.abs(alt._lr7live.st.h - st.h) < 2) {
      liveAuffrischen(alt, fm, au, rahmenSichtbar, st);
      setzeText(b.querySelector('.lr7-info'), fm.b + ' × ' + fm.h + ' cm · ' + RAHMEN[au].name);
      return;
    }
    if (SZENEN[a] && alt && alt._lr7 && !alt._lr7.foto && alt.getAttribute('data-art') === a && alt._lr7.au === au && Math.abs(alt._lr7.st.w - st.w) < 2 && Math.abs(alt._lr7.st.h - st.h) < 2 && (alt._lr7.fm.b !== fm.b || alt._lr7.fm.h !== fm.h)) {
      groesseAnimieren(alt, fm);
      setzeText(b.querySelector('.lr7-info'), fm.b + ' × ' + fm.h + ' cm · ' + RAHMEN[au].name + ' · maßstabsgetreu');
      return;
    }
    var neuEl;
    if (a === 'live') { neuEl = live(fm, au, rahmenSichtbar, st); if (zoomLid) setTimeout(function(){ textZoom(zoomLid); }, 40); }
    else if (SZENEN[a]) neuEl = szene(SZENEN[a], fm, au, st);
    else if (a === 'dreh') neuEl = dreh(fm, au, st);
    else neuEl = groessen(fm, au, st);
    /* weicher Wechsel: neue Ebene über die alte blenden */
    var alte = [].slice.call(feld.children);
    var gleich = alt && feld.lastElementChild.getAttribute('data-art') === a;
    if (gleich) { alte.forEach(function(x){ feld.removeChild(x); }); feld.appendChild(neuEl); }
    else {
      /* Ladereihenfolge: erst der Hintergrund, dann das Motiv. Die neue Ebene haengt
         zwar schon im Baum, bleibt aber unsichtbar, bis ihr Szenenfoto geladen ist –
         sonst sieht man kurz das nackte Poster ohne Zimmer. */
      neuEl.classList.add('lr7-haelt'); feld.appendChild(neuEl);
      wennBildDa(neuEl, function(){
        neuEl.classList.remove('lr7-haelt'); neuEl.classList.add('lr7-rein');
        alte.forEach(function(x){ x.classList.add('lr7-geht'); });
        setTimeout(function(){ alte.forEach(function(x){ if (x.parentNode) x.parentNode.removeChild(x); }); }, 400);
      });
    }
    var info;
    if (a === 'groessen') info = 'Alle Formate an derselben Wand – deins ist hervorgehoben';
    else if (SZENEN[a] && SZENEN[a].art === 'foto') info = 'Echte Aufnahme · Rahmen ' + SZENEN[a].rahmen + ' · dein Motiv im Bild';
    else info = fm.b + ' × ' + fm.h + ' cm · ' + RAHMEN[au].name + (SZENEN[a] ? ' · maßstabsgetreu' : a === 'dreh' ? ' · zum Drehen wischen' : '');
    setzeText(b.querySelector('.lr7-info'), info);
    if (a === 'dreh') laufen();
  };
  B.stopp = function(){ cancelAnimationFrame(B.raf); };

  /* --- Live: Studio, Poster groß; Rahmen erst im Schritt Produkt --- */
  function live(fm, au, rahmenSichtbar, st){
    var w = D.createElement('div'); w.className = 'lr7-live'; w.setAttribute('data-art', 'live');
    var z = D.createElement('div'); z.className = 'lr9-zoom'; w.appendChild(z);
    var r = rahmenEl(rahmenSichtbar ? au : 'ohne', fm, 8);
    r.style.transform = 'translate(-50%,-50%)';
    r.classList.add('lr7-rahmen--live');
    z.appendChild(r);
    w._lr7live = { st: st };
    liveAuffrischen(w, fm, au, rahmenSichtbar, st);
    return w;
  }
  /* Rahmen, Größe und Motiv der Live-Ansicht ohne Neuaufbau nachziehen */
  function liveAuffrischen(w, fm, au, rahmenSichtbar, st){
    var r = w.querySelector('.lr7-rahmen'); if (!r) return;
    var schl = rahmenSichtbar ? au : 'ohne', ohne = schl === 'ohne' || schl === 'leinwand';
    var L = ohne ? 0 : LEISTE, m = masse(fm);
    var ppc = Math.min(st.w * (HANDY ? .9 : .82) / (m.papier.b + 2 * L), st.h * (HANDY ? .93 : .88) / (m.papier.h + 2 * L));
    if (r.getAttribute('data-schl') !== schl) {
      r.className = 'lr7-rahmen lr7-rahmen--' + schl + ' lr7-rahmen--live';
      r.setAttribute('data-schl', schl);
      r.style.borderImageSource = ohne ? 'none' : 'url(' + BILD['r_' + schl] + ')';
      if (rahmenSichtbar && B.rahmenNeu) { r.classList.add('lr7-rahmen--kommt'); B.rahmenNeu = false; }
    }
    r.style.width = ((m.papier.b + 2 * L) * ppc).toFixed(1) + 'px';
    r.style.height = ((m.papier.h + 2 * L) * ppc).toFixed(1) + 'px';
    r.style.borderWidth = (L * ppc).toFixed(1) + 'px';
    /* Gestalter 9: Ebenen statt eines Gesamtbilds – neu aufbauen, wenn teeinblue die Ebenen tauscht */
    var a = artwork(), p = r.querySelector('.lr7-papier'), vorh = p && p.querySelector('svg[data-sig]');
    if (a && p && (!vorh || vorh.getAttribute('data-sig') !== ebenenSig(a))) {
      $$('svg:not(.lr9-schnapp)', p).forEach(function(x){ p.removeChild(x); });
      var sv = schichtenSvg(); if (sv) p.insertBefore(sv, p.firstChild);
    }
    w._lr7live = { st: st, fm: fm, au: schl };
  }
  function rahmenAuftritt(){ B.rahmenNeu = true; }

  /* --- Szene: Poster in Echtgröße in die Raumaufnahme projiziert --- */
  function szene(Z, fm, au, st){
    var w = D.createElement('div'); w.className = 'lr7-szene lr7-szene--' + (Z.art || 'bau'); w.setAttribute('data-art', B.ansicht);
    var q0 = Z.quad, fx = (q0[0][0] + q0[1][0] + q0[2][0] + q0[3][0]) / 4, fy = (q0[0][1] + q0[1][1] + q0[2][1] + q0[3][1]) / 4;
    /* Ausschnitt: möglichst viel vom Foto zeigen (Lucas Wunsch), leicht auf das Poster ausgerichtet.
       Gerechnet wird in 1024er-Koordinaten (so sind die Vierecke gemessen), s = Pixel je 1024er-Einheit. */
    var s = Math.min(st.w / 1024, st.h / 1024) * (Z.zoom || 1);
    var BR = 1024 * s;
    var ox = BR > st.w ? Math.min(0, Math.max(st.w - BR, st.w / 2 - fx * s)) : (st.w - BR) / 2;
    var oy = BR > st.h ? Math.min(0, Math.max(st.h - BR, st.h / 2 - fy * s)) : (st.h - BR) / 2;
    var lage = 'width:' + BR + 'px;height:' + BR + 'px;left:' + ox + 'px;top:' + oy + 'px';
    var img = D.createElement('img'); img.className = 'lr7-szene__bild'; img.alt = ''; img.decoding = 'async'; img.src = bildFuer(Z, BR);
    img.style.cssText = lage;
    w.appendChild(img);
    var polygon = function(e){ return 'polygon(' + [e[0], e[1], e[3], e[2]].map(function(p){ return (p[0] - ox).toFixed(1) + 'px ' + (p[1] - oy).toFixed(1) + 'px'; }).join(',') + ')'; };

    if (Z.art === 'foto') {
      /* Der Rahmen steht im Foto. Nur das Blatt wird ersetzt – Licht, Falzschatten und Tiefenschärfe
         kommen aus derselben Aufnahme, deshalb wirkt nichts aufgeklebt. */
      /* Vierecke der Fotos stehen als ol, or, ur, ul – für Abbildung und Maske auf ol, or, ul, ur drehen */
      var roh = q0.map(function(p){ return [ox + p[0] * s, oy + p[1] * s]; });
      var ecken = [roh[0], roh[1], roh[3], roh[2]];
      var ziel = ecken;
      var bw = Math.hypot(q0[1][0] - q0[0][0], q0[1][1] - q0[0][1]) * s;
      var bh = Math.hypot(q0[3][0] - q0[0][0], q0[3][1] - q0[0][1]) * s;
      var pap = D.createElement('div'); pap.className = 'lr7-blatt';
      var UE = 2;   /* doppelt zeichnen, dann verkleinern – sonst rechnet der Browser die schräge Ebene weich */
      pap.style.width = (bw * UE) + 'px'; pap.style.height = (bh * UE) + 'px';
      pap.style.transform = matrix3d(bw * UE, bh * UE, ziel);
      if (Z.weich) pap.style.filter = 'blur(' + Z.weich + 'px)';
      var sv = schichtenSvg() || posterSvg(); if (sv) pap.appendChild(sv);
      w.appendChild(pap);
      if (Z.licht) {
        var li = D.createElement('img'); li.className = 'lr7-licht lr7-licht--voll'; li.alt = ''; li.src = Z.licht;
        li.style.cssText = lage; li.style.clipPath = polygon(ecken); w.appendChild(li);
      }
      if (Z.glanz) {
        var gl = D.createElement('img'); gl.className = 'lr7-glanz'; gl.alt = ''; gl.src = Z.glanz;
        gl.style.cssText = lage; gl.style.clipPath = polygon(ecken); w.appendChild(gl);
      }
      if (BILD.korn) {
        var kn = D.createElement('div'); kn.className = 'lr7-korn';
        kn.style.cssText = lage; kn.style.backgroundImage = 'url(' + BILD.korn + ')'; kn.style.clipPath = polygon(ecken);
        w.appendChild(kn);
      }
      w._lr7 = { Z: Z, au: au, fm: fm, st: st, s: s, ox: ox, oy: oy, foto: true };
      return w;
    }

    var r = rahmenEl(au, { b: fm.b, h: fm.h }); r.classList.add('lr7-rahmen--szene');
    var sh = D.createElement('div'); sh.className = 'lr7-schatten';
    w.appendChild(sh); w.appendChild(r);
    var li2 = null;
    /* Lichtkarte voll: sie ist auf weißes Papier geeicht (Helligkeit und Wärme des Raumlichts),
       deshalb nicht abschwächen – sonst bleibt das Poster strahlend weiß und wirkt aufgeklebt. */
    if (Z.licht) { li2 = D.createElement('img'); li2.className = 'lr7-licht lr7-licht--voll'; li2.alt = ''; li2.src = Z.licht; li2.style.cssText = lage; w.appendChild(li2); }
    var kn2 = null;
    if (BILD.korn) { kn2 = D.createElement('div'); kn2.className = 'lr7-korn'; kn2.style.cssText = lage; kn2.style.backgroundImage = 'url(' + BILD.korn + ')'; w.appendChild(kn2); }
    w._lr7 = { Z: Z, au: au, fm: fm, st: st, s: s, ox: ox, oy: oy, r: r, sh: sh, li: li2, kn: kn2 };
    szenenLage(w, fm.b, fm.h);
    return w;
  }

  /* Lage von Rahmen, Schatten und Licht für eine (auch krumme, animierte) Postergröße */
  function szenenLage(w, pb, ph){
    var g = w._lr7, Z = g.Z, s = g.s, ox = g.ox, oy = g.oy;
    var q = Z.quad, w0 = Z.cm[0], h0 = Z.cm[1];
    var Hm = homographie([[0, 0], [w0, 0], [0, h0], [w0, h0]], [q[0], q[1], q[3], q[2]]);
    var ohne = g.au === 'ohne' || g.au === 'leinwand';
    var mm = masse({ b: Math.round(pb), h: Math.round(ph) }), L = ohne ? 0 : mm.leiste;
    var eb = pb - 2 * L, eh = ph - 2 * L;
    if (Z.anker === 'fest') { var k = h0 / eh; eb *= k; eh *= k; }
    var ob = eb + 2 * L, oh = eh + 2 * L, x0, y0;
    if (Z.anker === 'boden') { x0 = w0 / 2 - ob / 2; y0 = h0 + LEISTE - oh; } else { x0 = w0 / 2 - ob / 2; y0 = h0 / 2 - oh / 2; }
    var ecken = [[x0, y0], [x0 + ob, y0], [x0, y0 + oh], [x0 + ob, y0 + oh]].map(function(p){ var v = proj(Hm, p[0], p[1]); return [ox + v[0] * s, oy + v[1] * s]; });
    var breiteAmSchirm = Math.hypot(ecken[1][0] - ecken[0][0], ecken[1][1] - ecken[0][1]);
    var ppc = Math.max(4, breiteAmSchirm / ob) * 2;   /* doppelt zeichnen, Matrix verkleinert wieder */
    var rw = ob * ppc, rh = oh * ppc;
    if (g.r.getAttribute('data-ppc') !== String(Math.round(ppc))) {
      g.r.setAttribute('data-ppc', String(Math.round(ppc)));
      if (g.r.style.borderWidth) g.r.style.borderWidth = (L * ppc).toFixed(1) + 'px';
    }
    g.r.style.width = rw + 'px'; g.r.style.height = rh + 'px';
    var t = matrix3d(rw, rh, ecken);
    g.r.style.transform = t;
    g.sh.style.width = rw + 'px'; g.sh.style.height = rh + 'px'; g.sh.style.transform = t;
    var sc = Z.schatten, ks = ppc;
    g.sh.style.boxShadow = (sc[0] * ks).toFixed(1) + 'px ' + (sc[1] * ks).toFixed(1) + 'px ' + (sc[2] * ks).toFixed(1) + 'px rgba(40,28,15,' + sc[3] + '), ' + (sc[0] * ks * .25).toFixed(1) + 'px ' + (sc[1] * ks * .25).toFixed(1) + 'px ' + (sc[2] * ks * .2).toFixed(1) + 'px rgba(30,20,10,.28)';
    var pol = 'polygon(' + [ecken[0], ecken[1], ecken[3], ecken[2]].map(function(p){ return (p[0] - ox).toFixed(1) + 'px ' + (p[1] - oy).toFixed(1) + 'px'; }).join(',') + ')';
    if (g.li) g.li.style.clipPath = pol;
    if (g.kn) g.kn.style.clipPath = pol;
    g.fm = { b: pb, h: ph };
  }
  /* Größe fließend ändern: dieselbe Szene, nur das Poster wächst oder schrumpft */
  function groesseAnimieren(w, ziel){
    var von = w._lr7.fm, t0 = performance.now(), dauer = (RUHIG || D.hidden) ? 0 : 480;
    cancelAnimationFrame(B.rafG); clearTimeout(B.tG);
    B.tG = setTimeout(function(){ cancelAnimationFrame(B.rafG); szenenLage(w, ziel.b, ziel.h); }, dauer + 80);
    (function schritt(t){
      var x = dauer ? Math.min(1, (t - t0) / dauer) : 1, e = 1 - Math.pow(1 - x, 3);
      szenenLage(w, von.b + (ziel.b - von.b) * e, von.h + (ziel.h - von.h) * e);
      if (x < 1) B.rafG = requestAnimationFrame(schritt);
    })(t0);
  }

  /* --- Größenvergleich: dieselbe Wand, drei Formate im echten Verhältnis, mit dem Motiv des Kunden --- */
  function formate(){
    var c = camp(), l = [];
    $$('.tee-option--size .tee-radio-label', c || D).forEach(function(e){
      var m = (e.textContent || '').match(/(\d{2,3})\s*[x×]\s*(\d{2,3})/);
      if (m) { var a = [+m[1], +m[2]]; l.push([Math.min(a[0], a[1]), Math.max(a[0], a[1])]); }
    });
    l.sort(function(a, b){ return a[0] - b[0]; });
    return l.length ? l : [[30, 40], [40, 60]];
  }
  function groessen(fm, au, st){
    var Z = GROESSEN_SZENE;
    var w = D.createElement('div'); w.className = 'lr7-szene lr7-szene--groessen'; w.setAttribute('data-art', 'groessen');
    var s = Math.min(st.w / 1024, st.h / 1024) * (Z.zoom || 1.1), BR = 1024 * s;
    var mp = [(Z.quad[0][0] + Z.quad[1][0] + Z.quad[2][0] + Z.quad[3][0]) / 4, (Z.quad[0][1] + Z.quad[1][1] + Z.quad[2][1] + Z.quad[3][1]) / 4];
    var ox = BR > st.w ? Math.min(0, Math.max(st.w - BR, st.w / 2 - mp[0] * s)) : (st.w - BR) / 2;
    var oy = BR > st.h ? Math.min(0, Math.max(st.h - BR, st.h / 2 - mp[1] * s)) : (st.h - BR) / 2;
    var img = D.createElement('img'); img.className = 'lr7-szene__bild'; img.alt = ''; img.decoding = 'async';
    img.src = bildFuer(Z, BR);
    img.style.cssText = 'width:' + BR + 'px;height:' + BR + 'px;left:' + ox + 'px;top:' + oy + 'px';
    w.appendChild(img);
    var q = Z.quad, w0 = Z.cm[0], h0 = Z.cm[1];
    var Hm = homographie([[0, 0], [w0, 0], [0, h0], [w0, h0]], [q[0], q[1], q[3], q[2]]);
    var P = function(u, v){ var p = proj(Hm, u, v); return [ox + p[0] * s, oy + p[1] * s]; };
    var lueck = 9;
    var FORMATE = formate();
    var ges = FORMATE.reduce(function(a, f){ return a + f[0]; }, 0) + lueck * (FORMATE.length - 1);
    var x = w0 / 2 - ges / 2, unterkante = h0 / 2 + FORMATE[FORMATE.length - 1][1] / 2;
    FORMATE.forEach(function(f){
      var ob = f[0], oh = f[1], y0 = unterkante - oh;
      var ecken = [P(x, y0), P(x + ob, y0), P(x, y0 + oh), P(x + ob, y0 + oh)];
      var ppc = Math.max(4, Math.hypot(ecken[1][0] - ecken[0][0], ecken[1][1] - ecken[0][1]) / ob) * 2;
      var r = rahmenEl(au, { b: f[0], h: f[1] }, ppc); r.classList.add('lr7-rahmen--szene');
      var rw = ob * ppc, rh = oh * ppc, t = matrix3d(rw, rh, ecken);
      r.style.transform = t;
      var sh = D.createElement('div'); sh.className = 'lr7-schatten';
      sh.style.width = rw + 'px'; sh.style.height = rh + 'px'; sh.style.transform = t;
      sh.style.boxShadow = (0.9 * ppc).toFixed(1) + 'px ' + (1.6 * ppc).toFixed(1) + 'px ' + (2.6 * ppc).toFixed(1) + 'px rgba(40,28,15,.30)';
      w.appendChild(sh); w.appendChild(r);
      /* Raumlicht liegt nur auf dem Bild, nicht auf dem ganzen Zimmer */
      if (Z.licht) {
        var li = D.createElement('img'); li.className = 'lr7-licht lr7-licht--voll'; li.alt = ''; li.src = Z.licht;
        li.style.cssText = img.style.cssText;
        li.style.clipPath = 'polygon(' + [ecken[0], ecken[1], ecken[3], ecken[2]].map(function(p){ return (p[0] - ox).toFixed(1) + 'px ' + (p[1] - oy).toFixed(1) + 'px'; }).join(',') + ')';
        w.appendChild(li);
      }
      var an = f[0] === fm.b && f[1] === fm.h;
      var be = D.createElement('div'); be.className = 'lr7-mass' + (an ? ' an' : '');
      be.textContent = f[0] + ' × ' + f[1] + ' cm';
      var u = P(x + ob / 2, y0 + oh);
      be.style.left = u[0] + 'px'; be.style.top = (u[1] + 12) + 'px';
      w.appendChild(be);
      x += ob + lueck;
    });
    return w;
  }

  /* --- 360°: echter Rahmenkörper mit Holzkanten und Rückwand --- */
  var drehEl = null;
  function dreh(fm, au, st){
    var w = D.createElement('div'); w.className = 'lr7-dreh'; w.setAttribute('data-art', 'dreh');
    var ohne = au === 'ohne', lw = au === 'leinwand';
    var T = lw ? 2.0 : ohne ? 0.15 : 2.4;  /* Tiefe in cm */
    /* Aussenmass GENAU so, wie rahmenEl den Rahmen wirklich zeichnet. Vorher wurde die
       Leiste zweimal gerechnet – der Koerper stand dann 3 cm ueber und es klaffte ein
       heller Rand rechts und unten, die Seitenkanten schwebten daneben. */
    var mm = masse(fm), LL = (ohne || lw) ? 0 : mm.leiste;
    var ob = mm.papier.b + 2 * LL, oh = mm.papier.h + 2 * LL;
    var ppc = Math.min(st.h * .62 / oh, st.w * .58 / ob) * 2;
    var W = ob * ppc, Hh = oh * ppc, Tp = T * ppc;
    w.innerHTML = '<div class="lr7-dreh__boden"></div><div class="lr7-dreh__raum"><div class="lr7-dreh__koerper"></div></div>';
    var k = w.querySelector('.lr7-dreh__koerper');
    k.style.width = W + 'px'; k.style.height = Hh + 'px';
    k.style.setProperty('--s', '0.5');
    var vorne = rahmenEl(au, fm, ppc); vorne.classList.add('lr7-dreh__vorne'); vorne.style.transform = 'translateZ(' + (Tp / 2) + 'px)';
    k.appendChild(vorne);
    var kante = lw ? '' : 'url(' + BILD['k_' + (ohne ? 'weiss' : au)] + ')';
    var seiten = [
      ['hinten', W, Hh, 'rotateY(180deg) translateZ(' + (Tp / 2) + 'px)'],
      ['links', Tp, Hh, 'translateX(' + (-Tp / 2) + 'px) rotateY(-90deg)', 0],
      ['rechts', Tp, Hh, 'translateX(' + (W - Tp / 2) + 'px) rotateY(90deg)'],
      ['oben', W, Tp, 'translateY(' + (-Tp / 2) + 'px) rotateX(90deg)'],
      ['unten', W, Tp, 'translateY(' + (Hh - Tp / 2) + 'px) rotateX(-90deg)']
    ];
    seiten.forEach(function(sd){
      var e = D.createElement('div'); e.className = 'lr7-dreh__seite lr7-dreh__' + sd[0];
      e.style.width = sd[1] + 'px'; e.style.height = sd[2] + 'px'; e.style.transform = sd[3];
      if (sd[0] === 'hinten') e.style.backgroundImage = lw ? 'none' : 'url(' + BILD.rueckwand + ')';
      else if (sd[0] === 'oben' || sd[0] === 'unten') { if (kante) e.style.backgroundImage = 'url(' + BILD['kh_' + (ohne ? 'weiss' : au)] + ')'; }
      else if (kante) e.style.backgroundImage = kante;
      if (lw) e.style.background = sd[0] === 'hinten' ? '#E9E1D3' : '#F4F1EC';
      e.appendChild(D.createElement('i'));
      k.appendChild(e);
    });
    drehEl = w;
    /* Ziehen zum Drehen */
    var zieh = null;
    w.addEventListener('pointerdown', function(e){ zieh = { x: e.clientX, y: e.clientY, w: B.winkel, k: B.kipp }; B.auto = false; B.zuletzt = Date.now(); try { w.setPointerCapture(e.pointerId); } catch (x) {} });
    w.addEventListener('pointermove', function(e){ if (!zieh) return; B.winkel = zieh.w + (e.clientX - zieh.x) * .55; B.kipp = Math.max(-22, Math.min(22, zieh.k - (e.clientY - zieh.y) * .22)); stelle(); });
    ['pointerup', 'pointercancel'].forEach(function(t){ w.addEventListener(t, function(){ zieh = null; B.zuletzt = Date.now(); }); });
    setTimeout(stelle, 0);
    return w;
  }
  function stelle(){
    if (!drehEl) return;
    var k = drehEl.querySelector('.lr7-dreh__koerper'); if (!k) return;
    k.style.transform = 'translate(-50%,-50%) scale(var(--s)) rotateX(' + B.kipp.toFixed(1) + 'deg) rotateY(' + B.winkel.toFixed(1) + 'deg)';
    /* Licht von oben links: Seiten je nach Winkel heller/dunkler, Glas-Glanz wandert */
    var rad = B.winkel * Math.PI / 180, c = Math.cos(rad), s = Math.sin(rad);
    var dunkel = function(x){ return Math.max(0, Math.min(.6, x)).toFixed(3); };
    var set = function(n, v){ var e = k.querySelector('.lr7-dreh__' + n + ' i'); if (e) e.style.opacity = v; };
    set('links', dunkel(.12 + .35 * Math.max(0, -s)));
    set('rechts', dunkel(.32 + .3 * Math.max(0, s)));
    set('oben', dunkel(.05));
    set('unten', dunkel(.45));
    set('hinten', dunkel(.18 + .2 * Math.max(0, c)));
    k.style.setProperty('--glanz', (50 + s * 60).toFixed(1) + '%');
    var bo = drehEl.querySelector('.lr7-dreh__boden'); if (bo) bo.style.transform = 'translateX(-50%) scaleX(' + (0.55 + .45 * Math.abs(c)).toFixed(3) + ')';
  }
  function laufen(){
    cancelAnimationFrame(B.raf);
    if (RUHIG) { stelle(); return; }
    var t0 = performance.now();
    (function schritt(t){
      if (B.ansicht !== 'dreh' || !D.body.classList.contains('lr-gestalten') || D.hidden) return;
      if (!B.auto && Date.now() - B.zuletzt > 3500) B.auto = true;
      if (B.auto) { B.winkel += (t - t0) * .024; if (B.winkel > 180) B.winkel -= 360; stelle(); }
      t0 = t; B.raf = requestAnimationFrame(schritt);
    })(t0);
  }
  D.addEventListener('visibilitychange', function(){ if (!D.hidden && B.ansicht === 'dreh') laufen(); });

  /* ================= Schritt Produkt: Rahmen mit Materialfotos ================= */
  function produktPanel(){
    var halter = $('.lr-halter'); if (!halter) return;
    var liste = ausfuehrungen();
    /* 29.09.2026 (Luca): Nur Poster ist der Normalpreis, Rahmen der Aufpreis -> 'Ohne Rahmen' zuerst und vorgewaehlt */
    liste = liste.filter(function(x){ return x.schl === 'ohne'; }).concat(liste.filter(function(x){ return x.schl !== 'ohne'; }));
    if (!B.rahmenGewaehlt && !B.ohneVorwahl && liste.length > 1 && liste[0].schl === 'ohne') {
      B.ohneVorwahl = true;
      if (!liste[0].aktiv) {
        (liste[0].radio.querySelector('label') || liste[0].radio.querySelector('input') || liste[0].radio).click();
        setTimeout(function(){ pflegePreise(); B.zeichne(true); }, 600);
      }
    }
    var box = $('.lr7-rahmenwahl');
    if (liste.length < 2 && !POSTER) {
      if (!box) { box = D.createElement('div'); box.className = 'lr7-rahmenwahl lr8-leer'; var u0 = halter.querySelector('.lr-gk-unter'); if (!u0) return; u0.parentNode.insertBefore(box, u0.nextSibling); }
    }
    else if (liste.length < 2) {
      /* nur eine Ausführung: Material trotzdem zeigen, als Info */
      if (!box) { box = D.createElement('div'); box.className = 'lr-gk-hinweis lr7-rahmenwahl lr7-rahmenwahl--info'; var u = halter.querySelector('.lr-gk-unter'); if (!u) return; u.parentNode.insertBefore(box, u.nextSibling); }
      var au = ausfuehrung();
      var h1 = '<p class="lr7-titel">Rahmen</p><div class="lr7-rw-reihe"><div class="lr7-rw an"><img src="' + BILD['e_' + au] + '" alt="" loading="lazy"><b>' + RAHMEN[au].name + '</b><small>' + RAHMEN[au].info + '</small></div></div>';
      if (RAHMEN[au] && box.getAttribute('data-stand') !== h1) { box.innerHTML = h1; box.setAttribute('data-stand', h1); }
    } else {
      if (!box || box.classList.contains('lr7-rahmenwahl--info')) {
        if (box) box.remove();
        box = D.createElement('div'); box.className = 'lr-gk-hinweis lr7-rahmenwahl';
        var u2 = halter.querySelector('.lr-gk-unter'); if (!u2) return; u2.parentNode.insertBefore(box, u2.nextSibling);
        box.addEventListener('click', function(e){
          var k = e.target.closest('[data-basis]'); if (!k) return;
          var a = ausfuehrungen().filter(function(x){ return x.id === k.getAttribute('data-basis'); })[0]; if (!a) return;
          /* 29.09.2026 (Luca): Rahmen ist ein Zusatz – aktiven Rahmen erneut antippen bzw. X = Rahmen weg (Poster pur) */
          if (box.classList.contains('lr9-zusatz') && k.classList.contains('an')) { a = ausfuehrungen().filter(function(x){ return x.schl === 'ohne'; })[0]; if (!a) return; }
          B.rahmenGewaehlt = true; B.rahmenNeu = true; B.angefasst = true; B.ausfZeit = Date.now();
          $$('[data-basis]', box).forEach(function(x){ var an = x === k && a.schl !== 'ohne'; x.classList.toggle('an', an); x.setAttribute('aria-pressed', an ? 'true' : 'false'); });
          (a.radio.querySelector('label') || a.radio.querySelector('input') || a.radio).click();
          materialBlick();
          /* in der laufenden Ansicht bleiben – der Rahmen wechselt dort, nichts springt */
          setTimeout(function(){ takt(); B.zeichne(true); }, 120);
          setTimeout(function(){ pflegePreise(); B.zeichne(true); }, 600);
        });
      }
      var zusatz = liste[0].schl === 'ohne', karten = zusatz ? liste.slice(1) : liste;
      box.classList.toggle('lr9-zusatz', zusatz);
      var basis = S.ausfPreis ? Math.min.apply(null, Object.keys(S.ausfPreis).map(function(k){ return S.ausfPreis[k]; })) : null;
      var fm9 = format();
      var h = (zusatz ? '<p class="lr7-titel">Rahmen dazu? <small>optional · kommt fertig zum Aufhängen</small></p>' : '<p class="lr7-titel">Rahmen <small>kommt fertig zum Aufhängen</small></p>') + '<div class="lr9-rk-reihe">' + karten.map(function(a){
        var p = S.ausfPreis && S.ausfPreis[Object.keys(S.ausfPreis).filter(function(n){ return n.replace(/\s+/g, ' ').trim() === a.titel; })[0]];
        var auf = (p != null && basis != null) ? p - basis : null;
        var info = RAHMEN[a.schl] || { name: a.titel, info: '' };
        return '<button type="button" class="lr9-rk' + (a.aktiv ? ' an' : '') + '" data-basis="' + a.id + '"' + (zusatz ? ' aria-pressed="' + (a.aktiv ? 'true' : 'false') + '" title="' + (a.aktiv ? 'Rahmen entfernen' : 'Rahmen dazunehmen') + '"' : '') + '><span class="lr9-rk-mini" data-mini="' + a.schl + '" style="--material:url(' + (BILD['e_' + a.schl] || '') + ')"></span><span class="lr9-rk-text"><b>' + info.name + '</b><small>' + info.info + '</small></span><em>' + (auf == null ? '' : auf <= 0 ? 'im Preis' : '+ ' + geld(auf)) + '</em></button>';
      }).join('') + '</div>';
      var stand9 = h + '|' + fm9.b + 'x' + fm9.h + '|' + ebenenSig(artwork());
      if (box.getAttribute('data-stand') !== stand9) {
        box.innerHTML = h; box.setAttribute('data-stand', stand9);
        $$('[data-mini]', box).forEach(function(sp, n){
          var schl = sp.getAttribute('data-mini'), m = masse(fm9), L = (schl === 'ohne' || schl === 'leinwand') ? 0 : LEISTE;
          var ppc = 58 / (m.papier.b + 2 * L), r = rahmenEl(schl, fm9, ppc); r.style.position = 'relative'; r.style.transform = 'none';
          var pp = r.querySelector('.lr7-papier'); pp.innerHTML = ''; var sv = schichtenSvg(); if (sv) pp.appendChild(sv);
          sp.appendChild(r); sp.parentNode.style.setProperty('--i', n);
        });
      }
      $$('.lr9-rk', box).forEach(function(b){ var a = liste.filter(function(x){ return x.id === b.getAttribute('data-basis'); })[0]; b.classList.toggle('an', !!(a && a.aktiv)); b.setAttribute('title', zusatz ? (a && a.aktiv ? 'Rahmen entfernen' : 'Rahmen dazunehmen') : ''); });
    }
    var zeigen = S.reiter === 'produkt' && D.body.classList.contains('lr-gestalten');
    box.hidden = !zeigen;
    var zu = $('.lr8-zusatz');
    if (!zu) {
      zu = D.createElement('div'); zu.className = 'lr-gk-hinweis lr8-zusatz';
      zu.innerHTML = (window.LR_KARTE ? '<label class="lr-zusatz"><input type="checkbox" data-lr-karte> <span><b>Grußkarte dazu</b> mit deinen Worten</span><em>+ ' + geld(window.LR_KARTE.preis) + '</em></label>' : '') +
        '<p class="lr-hinweis">Wird nur für dich gefertigt und ist deshalb vom Widerruf ausgeschlossen. Fehler bei uns? Wir fertigen neu.</p>';
      box.parentNode.insertBefore(zu, box.nextSibling);
    }
    zu.hidden = !(S.reiter === 'pruefen' && D.body.classList.contains('lr-gestalten'));
    D.body.classList.toggle('lr7-hat-rahmenwahl', liste.length >= 2);
  }

  /* ================= Schritt Design: Kategorien + Designfamilie + Motiv ================= */
  /* Familien: jedes Design ist (noch) ein eigenes Produkt. Wechsel nimmt Ort und Texte mit. */
  var FAMILIEN = {
    /* Zwoelf Stadtkarten-Designs (24.09.2026). Die Handles bleiben die alten, damit
       bestehende Links weiter greifen – angezeigt wird der neue Designname. */
    stadtkarte: { titel: 'Stadtkarte', kat: ['Vollbild', 'Mit Rand', 'Kreis', 'Herz'], liste: [
      ['nordlicht-stadtkarte-mit-eurem-ort', 'LINIE', 'Mit Rand'], ['weite-stadtkarte-mit-eurem-ort', 'HERZ', 'Herz'],
      ['herzlinie-stadtkarte-mit-eurem-ort', 'NACHT', 'Vollbild'], ['zwiesprache-stadtkarte-mit-eurem-ort', 'KREIS', 'Kreis'],
      ['ronde-stadtkarte-mit-eurem-ort', 'GALERIE', 'Mit Rand'], ['zweiklang-stadtkarte-mit-eurem-ort', 'RING', 'Kreis'],
      ['fassade-stadtkarte-mit-eurem-ort', 'ZEILEN', 'Vollbild'], ['serola-stadtkarte-mit-eurem-ort', 'VIERTEL', 'Vollbild'],
      ['feder-stadtkarte-mit-eurem-ort', 'HERZFORM', 'Herz'], ['amour-stadtkarte-mit-eurem-ort', 'HERZLICHT', 'Herz'],
      ['reigen-stadtkarte-mit-eurem-ort', 'HERZPAAR', 'Herz'], ['tafel-stadtkarte-mit-eurem-ort', 'SPRUCH', 'Vollbild'] ] },
    sternenkarte: { titel: 'Sternenkarte', kat: ['Klassisch', 'Landschaft', 'Besonders'], liste: [
      ['zenit-sternenkarte-mit-eurem-himmel', 'ZENIT', 'Klassisch'], ['firmament-sternenkarte-mit-eurem-himmel', 'FIRMAMENT', 'Klassisch'],
      ['sternstunde-sternenkarte-mit-eurem-himmel', 'STERNSTUNDE', 'Klassisch'], ['lichtjahr-sternenkarte-mit-eurem-himmel', 'LICHTJAHR', 'Klassisch'],
      ['himmelszelt-sternenkarte-mit-eurem-himmel', 'HIMMELSZELT', 'Klassisch'], ['nachtglanz-sternenkarte-mit-eurem-himmel', 'NACHTGLANZ', 'Klassisch'],
      ['weitblick-sternenkarte-mit-eurem-himmel', 'WEITBLICK', 'Klassisch'], ['silberspur-sternenkarte-mit-eurem-himmel', 'SILBERSPUR', 'Klassisch'],
      ['aurora-sternenkarte-polarlicht', 'AURORA', 'Landschaft'],
      ['sola-sternenkarte-dammerung-am-meer', 'SOLA', 'Landschaft'], ['nebla-sternenkarte-nebel-uber-dem-see', 'NEBLA', 'Landschaft'],
      ['sternenkarte-block-euer-himmel-viereckig', 'BLOCK', 'Besonders'], ['sternenkarte-zwei-himmel-zwei-leben-ein-himmel', 'ZWEI HIMMEL', 'Besonders'],
      ['sternenkarte-familienhimmel-ein-himmel-pro-kind', 'FAMILIENHIMMEL', 'Besonders'], ['sternenkarte-drei-momente-eure-geschichte-in-sternen', 'DREI MOMENTE', 'Besonders'],
      ['sternenkarte-himmel-erde-sterne-und-stadtkarte', 'HIMMEL & ERDE', 'Besonders'], ['sternenkarte-foto-himmel-euer-foto-am-sternenhimmel', 'FOTO + HIMMEL', 'Besonders']  ] }
  };
  function familie(){
    var h = handle();
    for (var k in FAMILIEN) if (FAMILIEN[k].liste.some(function(x){ return x[0] === h; })) return FAMILIEN[k];
    return null;
  }
  var bildCache = {};
  function ladeKachelbild(h, img){
    if (bildCache[h]) { img.src = bildCache[h]; return; }
    fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      if (!p || !p.featured_image) { var b = img.closest('button'); if (b) b.hidden = true; return; }
      var u = p.featured_image; u = (u.indexOf('//') === 0 ? 'https:' : '') + u; u += (u.indexOf('?') > 0 ? '&' : '?') + 'width=300';
      bildCache[h] = u; img.src = u;
    }).catch(function(){});
  }
  var katWahl = null;
  function designPanel(){
    var halter = $('.lr-halter'); if (!halter) return;
    var box = $('.lr7-designs');
    if (!box) {
      box = D.createElement('div'); box.className = 'lr-gk-hinweis lr7-designs';
      /* Gestalter 8: erst Ort & Worte, dann Design (Messung 28.09.: Ort stand zu tief) – Box hinter das teeinblue-Formular */
      var cc = camp();
      if (cc && cc.parentNode && halter.contains(cc)) cc.parentNode.insertBefore(box, cc.nextSibling);
      else { var u = halter.querySelector('.lr-gk-unter'); if (!u) return; u.parentNode.insertBefore(box, u.nextSibling); }
      box.addEventListener('click', function(e){
        var k = e.target.closest('[data-lr7-kat]');
        if (k) { katWahl = k.getAttribute('data-lr7-kat'); designPanel(true); return; }
        var f = e.target.closest('[data-lr7-familie]');
        if (f) { var h = f.getAttribute('data-lr7-familie'); if (h !== handle()) { wechselAnzeigen(f); merken(); try { sessionStorage.setItem('lr7-wechsel', '1'); } catch (x) {} f.classList.add('laedt'); var ms = abgang(); setTimeout(function(){ location.href = '/products/' + h + '#gestalten-design'; }, ms); } return; }
        var m = e.target.closest('[data-lr7-motiv]');
        if (m) { var v = vorlageWahl(); if (v) { v.setze(m.getAttribute('data-lr7-motiv')); setTimeout(designPanel, 50); setTimeout(designPanel, 500); } }
      });
      /* Ein Designwechsel laedt eine andere Produktseite. Damit das nicht wie ein Absturz
         wirkt, holen wir die Zielseite schon, waehrend der Finger noch auf der Kachel liegt.
         Chrome kann sie sogar vollstaendig vorbereiten (Speculation Rules); sonst reicht
         das Vorladen des Dokuments. Hoechstens zwei gleichzeitig, sonst wird es teuer. */
      var geholt = {}, offen = [];
      function vorladen(hnd){
        if (!hnd || hnd === handle() || geholt[hnd]) return;
        geholt[hnd] = 1;
        var url = '/products/' + hnd;
        var ziel = url + '#gestalten-design';          /* genau die Adresse, auf die der Klick springt */
        try {
          if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
            var sk = D.createElement('script');
            sk.type = 'speculationrules';
            sk.textContent = JSON.stringify({ prerender: [{ source: 'list', urls: [ziel, url], eagerness: 'immediate' }] });
            D.head.appendChild(sk); offen.push(sk);
            while (offen.length > 2) { var alt = offen.shift(); if (alt.parentNode) alt.parentNode.removeChild(alt); }
          }
          var l = D.createElement('link'); l.rel = 'prefetch'; l.as = 'document'; l.href = url;
          D.head.appendChild(l);
        } catch (x) {}
      }
      function aufKachel(e){ var f = e.target.closest && e.target.closest('[data-lr7-familie]'); if (f) vorladen(f.getAttribute('data-lr7-familie')); }
      box.addEventListener('pointerenter', aufKachel, true);
      box.addEventListener('touchstart', aufKachel, { passive: true, capture: true });
      var fam = familie();
      var vorlage = $('[data-lr-designs] .lr-designs');
      var h = '';
      if (fam) {
        var akt = (fam.liste.filter(function(x){ return x[0] === handle(); })[0] || [])[2];
        katWahl = katWahl || akt || 'Alle';
        h += '<p class="lr7-titel">' + fam.titel + ' – Design wählen</p><div class="lr7-chips">' + ['Alle'].concat(fam.kat).map(function(k){ var n = k === 'Alle' ? fam.liste.length : fam.liste.filter(function(x){ return x[2] === k; }).length; return '<button type="button" data-lr7-kat="' + k + '">' + k + ' <small>' + n + '</small></button>'; }).join('') + '</div>' +
          '<div class="lr7-kacheln">' + fam.liste.map(function(x){ return '<button type="button" data-lr7-familie="' + x[0] + '" data-kat="' + x[2] + '"' + (x[0] === handle() ? ' class="an" aria-current="true"' : '') + '><img alt="" decoding="async" data-h="' + x[0] + '"><span>' + x[1] + '</span></button>'; }).join('') + '</div>';
      } else if (vorlage) {
        h += '<p class="lr7-titel">Design wählen</p><div class="lr7-kacheln lr7-kacheln--vorlagen">' + vorlage.innerHTML + '</div>';
      }
      h += '<div class="lr7-motive" hidden></div>';
      box.innerHTML = h;
      $$('img[data-h]', box).forEach(function(i){ ladeKachelbild(i.getAttribute('data-h'), i); });
      /* Designkarten gleiten gestaffelt herein, die gewählte rückt in Sicht */
      var kl = box.querySelector('.lr7-kacheln');
      if (kl) { kl.setAttribute('data-lr8-neu', ''); $$('button', kl).forEach(function(b, n){ b.style.setProperty('--i', n); });
        var an = kl.querySelector('.an'); if (an) setTimeout(function(){ kl.scrollLeft = Math.max(0, an.offsetLeft - 20); }, 30); }
      /* Frueher wurden hier alle zwoelf Geschwisterseiten auf Vorrat geholt: rund
         650 KB und 11 Anfragen bei JEDEM Seitenaufruf. Geholt wird jetzt erst beim
         Beruehren einer Kachel (siehe vorladen(hnd) weiter oben) – schnell genug,
         weil zwischen Beruehren und Klick immer etwas Zeit liegt. */
    }
    /* Kategorie-Filter */
    $$('[data-lr7-kat]', box).forEach(function(b){ b.classList.toggle('an', b.getAttribute('data-lr7-kat') === katWahl); });
    $$('[data-lr7-familie]', box).forEach(function(b){ var zeig = katWahl === 'Alle' || b.getAttribute('data-kat') === katWahl; if (b.hidden === zeig) b.hidden = !zeig; });
    /* Motiv (teeinblue-Vorlagen im selben Produkt, z. B. Weiß/Schwarz) als Knöpfe statt Auswahlliste */
    var s = vorlageWahl(), mo = box.querySelector('.lr7-motive');
    var hatKacheln = !!box.querySelector('[data-lr-design]');
    if (s && !hatKacheln && s.optionen.length > 1 && s.optionen.length <= 8 && !farbQuelle()) {
      var opts = s.optionen;
      var titel = ((s.feld.querySelector('.tee-field__heading') || {}).textContent || '').replace('*', '').trim() || 'Variante';
      /* Farbproben: kleine Kartenausschnitte statt blosser Woerter – nur wenn wir zu
         JEDER Vorlage ein Bild haben, sonst bleiben es die schlichten Textknoepfe. */
      var PROBEN = ['schwarz','weiss','blau','atlas','grau','nacht'];
      function farbSchluessel(t){
        return t.toLowerCase().replace(/\u00df/g,'ss').replace(/\u00e4/g,'ae')
                .replace(/\u00f6/g,'oe').replace(/\u00fc/g,'ue').replace(/[^a-z]/g,'');
      }
      var schluessel = opts.map(function(o){ return farbSchluessel(o.text); });
      var mitProben = schluessel.length > 1 && schluessel.every(function(k){ return PROBEN.indexOf(k) >= 0; });
      var hm = '<p class="lr7-titel">' + titel + '</p><div class="lr7-pillen' + (mitProben ? ' lr7-pillen--proben' : '') + '">' + opts.map(function(o, i){
        var t = o.text;
        return '<button type="button" data-lr7-motiv="' + o.wert + '" data-lr7-farbe="' + schluessel[i] + '"' + (o.wert === s.wert ? ' class="an"' : '') + '>'
             + (mitProben ? '<span class="lr7-probe"></span>' : '')
             + '<span class="lr7-probe-name">' + t + '</span></button>';
      }).join('') + '</div>';
      if (mo.getAttribute('data-stand') !== hm) { mo.innerHTML = hm; mo.setAttribute('data-stand', hm); }
      mo.hidden = false;
      s.feld.classList.add('lr7-select-ersetzt');
    } else mo.hidden = true;
    $$('[data-lr-design]', box).forEach(function(b){ b.classList.toggle('an', !!s && b.getAttribute('data-lr-design') === s.wert); });
    box.hidden = !(S.reiter === 'gestalten' && D.body.classList.contains('lr-gestalten'));
  }
  function templateSelect(){ return $('.tee-campaign .tee-field--template select'); }
  /* Die Vorlagenauswahl (bei uns "Farbe") liefert teeinblue je nach Artwork ENTWEDER als
     Auswahlliste ODER als Reihe von Miniaturbild-Radios. Der Gestalter kannte bisher nur
     die Liste. Bei Radios wurde deshalb nie eine Vorlage vorgewaehlt – teeinblue zeigte
     dann ueberhaupt keine Eingabefelder, oben blieben nur "Design" und "Produkt" stehen
     und der Text liess sich nicht bearbeiten. vorlageWahl() deckt beide Bauarten ab. */
  function idWahl(id){ return 'label[for="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]'; }
  function vorlageWahl(){
    var feld = $('.tee-campaign .tee-field--template'); if (!feld) return null;
    var s = feld.querySelector('select');
    if (s) {
      return { art: 'select', feld: feld, wert: (s.value && s.value !== 'null') ? s.value : '',
        optionen: [].filter.call(s.options, function(o){ return !o.disabled && o.value && o.value !== 'null'; })
                    .map(function(o){ return { wert: o.value, text: (o.textContent || '').trim() }; }),
        setze: function(v){ if (s.value === v) return false; s.value = v;
                            s.dispatchEvent(new Event('change', { bubbles: true })); return true; } };
    }
    var rr = $$('input[type=radio]', feld); if (!rr.length) return null;
    var an = rr.filter(function(r){ return r.checked; })[0];
    return { art: 'radio', feld: feld, wert: an ? an.value : '',
      optionen: rr.map(function(r){
        var l = feld.querySelector(idWahl(r.id));
        return { wert: r.value, text: ((l && (l.getAttribute('data-title') || l.textContent)) || r.value).trim() };
      }),
      /* Vue haengt am Label, nicht am versteckten Input – darum das Label anklicken. */
      setze: function(v){
        var z = rr.filter(function(r){ return r.value === v; })[0]; if (!z || z.checked) return false;
        var l = feld.querySelector(idWahl(z.id)); (l || z).click(); return true; } };
  }
  /* Der Wechsel lädt eine andere Produktseite. Damit es nicht aussieht, als würde der Gestalter
     schließen und neu aufgehen, liegt ein ruhiger Vorhang darüber – er wird schon vor dem Verlassen
     gezeigt und auf der neuen Seite (siehe lr7-laedt im Custom-Liquid) erst wieder entfernt,
     wenn der Gestalter offen ist. */
  /* Der Designwechsel laedt eine andere Produktseite. Browser mit Seitenuebergaengen
     (@view-transition in lr-gestalter7.css) blenden das weich um – dann darf KEIN
     Vorhang darueber liegen, sonst sieht man erst recht einen Seitenwechsel.
     Alle anderen bekommen den Vorhang, aber erst wenn es laenger als 220 ms dauert. */
  var WEICH = typeof D.startViewTransition === 'function';
  function wechselAnzeigen(kachel){
    if (WEICH) return;
    var b = kachel && kachel.querySelector('img');
    var quelle = b && b.currentSrc;
    setTimeout(function(){
      var v = $('.lr7-vorhang');
      if (!v) { v = D.createElement('div'); v.className = 'lr7-vorhang'; v.innerHTML = '<div class="lr7-vorhang__inhalt"><img alt="" class="lr7-vorhang__bild"></div>'; D.body.appendChild(v); }
      var bi = v.querySelector('.lr7-vorhang__bild');
      if (quelle) { bi.src = quelle; bi.hidden = false; } else bi.hidden = true;
      v.classList.add('an');
    }, 220);
  }
  /* Nachbarn vorladen, damit der Wechsel schnell ist */
  function familieVorladen(){
    var f = familie(); if (!f || window.__lr7vor) return; window.__lr7vor = 1;
    f.liste.slice(0, 12).forEach(function(x){
      if (x[0] === handle()) return;
      var l = D.createElement('link'); l.rel = 'prefetch'; l.href = '/products/' + x[0]; l.as = 'document';
      D.head.appendChild(l);
    });
  }
  D.addEventListener('click', function(e){
    var b = e.target.closest('.lr7-designs [data-lr-design]'); if (!b) return;
    e.preventDefault(); var s = vorlageWahl(); var v = b.getAttribute('data-lr-design');
    if (s && s.optionen.some(function(o){ return o.wert === v; })) { s.setze(v); setTimeout(designPanel, 50); }
  });
  /* Vorlage vorwählen: ?design=… oder erste freie */
  (function(){
    var wunsch = new URLSearchParams(location.search).get('design'), n = 0;
    /* Laeuft weiter, bis wirklich eine Vorlage steht. Ohne gewaehlte Vorlage baut
       teeinblue keine Eingabefelder – dann fehlen Moment und Text komplett. */
    var t = setInterval(function(){
      n++;
      var s = vorlageWahl();
      if (s && s.optionen.length) {
        var hat = s.optionen.some(function(o){ return o.wert === wunsch; });
        var v = (wunsch && hat) ? wunsch : (s.wert ? null : s.optionen[0].wert);
        if (v) s.setze(v);
        if (s.wert || v) { clearInterval(t); return; }
      }
      if (n > 80) clearInterval(t);
    }, 400);
  })();

  /* ---- Eingaben beim Designwechsel mitnehmen ---- */
  function feldName(f){ return ((f.querySelector('.tee-field__heading') || {}).textContent || '').replace('*', '').trim().toLowerCase(); }
  function merken(){
    var c = camp(); if (!c) return;
    var daten = { zeit: Date.now(), texte: {}, ort: '', motivIndex: null };
    $$('.tee-field', c).forEach(function(f){
      var n = feldName(f); if (!n) return;
      if (/tee-field--maps/.test(f.className)) { var mi = f.querySelector('.tee-field-maps'); var ot = mi ? mi.textContent.trim() : ''; if (ot && !/suchen/i.test(ot)) daten.ort = ot; return; }
      var i = f.querySelector('input.tee__input, textarea'); if (i && i.value && i.type !== 'hidden') daten.texte[n] = i.value;
    });
    var s = vorlageWahl(); if (s && s.wert) { daten.motivIndex = s.optionen.map(function(o){ return o.wert; }).indexOf(s.wert); }
    try { sessionStorage.setItem('lr7-mitnehmen', JSON.stringify(daten)); } catch (e) {}
  }
  function setzeWert(i, v){
    var proto = i.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(i, v);
    i.dispatchEvent(new Event('input', { bubbles: true })); i.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function uebernehmen(){
    var d = null; try { d = JSON.parse(sessionStorage.getItem('lr7-mitnehmen') || 'null'); } catch (e) {}
    if (!d || Date.now() - d.zeit > 15 * 60 * 1000) return;
    if (d.ort) { B.uebernahme = true; D.body.classList.add('lr7-ort-still'); setTimeout(function(){ B.uebernahme = false; D.body.classList.remove('lr7-ort-still'); }, 14000); }
    var n = 0, t = setInterval(function(){
      var c = camp(); n++;
      if (!c || !$('.tee-field', c)) { if (n > 30) clearInterval(t); return; }
      clearInterval(t);
      try { sessionStorage.removeItem('lr7-mitnehmen'); } catch (e) {}
      var s = vorlageWahl();
      if (s && d.motivIndex != null && d.motivIndex >= 0 && s.optionen[d.motivIndex]) s.setze(s.optionen[d.motivIndex].wert);
      setTimeout(function(){
        $$('.tee-field', c).forEach(function(f){
          var nme = feldName(f); var i = f.querySelector('input.tee__input, textarea');
          if (i && d.texte[nme] != null && i.value !== d.texte[nme]) setzeWert(i, d.texte[nme]);
        });
        if (d.ort) ortSetzen(d.ort);
      }, 700);
    }, 400);
  }
  /* Ort in einem neuen Design übernehmen: Kartendialog öffnen, suchen, ersten Treffer nehmen, übernehmen */
  function ortSetzen(ort){
    var feld = $('.tee-campaign .tee-field-maps'); if (!feld) return;
    karteHaken();
    D.body.classList.add('lr7-ort-still');
    var ende = function(){ D.body.classList.remove('lr7-ort-still'); B.uebernahme = false; };
    feld.click();
    var n = 0, t = setInterval(function(){
      n++;
      var dlg = $('.vm--container.tee-dialog-maps'), such = dlg && dlg.querySelector('.tee-maps__input');
      if (!such) { if (n > 30) { clearInterval(t); ende(); } return; }
      clearInterval(t);
      such.focus(); setzeWert(such, ort.split(',')[0].trim());
      var m = 0, t2 = setInterval(function(){
        m++;
        var treffer = dlg.querySelector('.tee-maps__searcher-item-content');
        if (!treffer) { if (m > 30) { clearInterval(t2); ende(); } return; }
        clearInterval(t2); treffer.click();
        setTimeout(function(){ heranzoomen(dlg, 0); }, 900);
        /* erst übernehmen, wenn die Karte fertig herangezoomt ist (sonst Leaflet-Fehler beim Schließen) */
        var k = 0, t3 = setInterval(function(){
          k++; var z = kartenZoom(dlg);
          if ((z != null && z >= ZIEL_ZOOM && k > 8) || k > 24) {
            clearInterval(t3);
            setTimeout(function(){
              var ok = dlg.querySelector('.tee-btn--primary') || [].filter.call(dlg.querySelectorAll('button'), function(b){ return /übernehmen|select/i.test(b.textContent); })[0];
              if (ok) ok.click(); ende();
            }, 500);
          }
        }, 250);
      }, 250);
    }, 250);
  }

  /* ================= Kartendialog (Leaflet): nach Ortswahl näher heranzoomen ================= */
  /* teeinblue passt die Karte an die Ausdehnung des Treffers an – bei Städten Stufe 9–11, viel zu weit draußen.
     Ziel: mindestens Stufe 13 (ganze Innenstadt sichtbar, Straßen gut lesbar). Adressen (Stufe 15+) bleiben. */
  var ZIEL_ZOOM = 14;
  function kartenZoom(dlg){
    var z = [].map.call(dlg.querySelectorAll('.leaflet-tile-container:last-of-type .leaflet-tile, .leaflet-tile'), function(i){ var m = (i.src || '').match(/\/(\d{1,2})\/\d+\/\d+(?:\.|@|\?|$)/); return m ? +m[1] : null; }).filter(function(x){ return x != null; });
    return z.length ? Math.max.apply(null, z) : null;
  }
  /* Leaflet-Karten des Dialogs mitschreiben (L.Map-Init-Hook), damit ohne Animation gezoomt werden kann */
  var karten = [];
  function karteHaken(){
    var L = window.L; if (!L || !L.Map || L.__lr7) return; L.__lr7 = 1;
    L.Map.addInitHook(function(){ karten.push(this); if (karten.length > 4) karten.shift(); });
    /* 29.09.2026: teeinblue reicht die Kartenkacheln über einen eigenen Zwischenspeicher durch, der alte
       Fassungen unserer Mapbox-Stile festhält (Köln z13+: dunkler statt weißer Rhein). Kacheln deshalb direkt
       und frisch von Mapbox holen – gleicher Stil, gleiche Kachel, öffentlicher Schlüssel der Kampagne. */
    var P = L.TileLayer && L.TileLayer.prototype;
    if (P && !P.__lrFrisch) {
      P.__lrFrisch = 1;
      var altUrl = P.getTileUrl;
      P.getTileUrl = function(c){
        var u = altUrl.call(this, c);
        var m = /\/maps\/tiles\/([\w-]+)\/(\w+)\/(\d+)\/(\d+)\/(\d+)\.png/.exec(u || '');
        var k = window.teeinblueCampaign && teeinblueCampaign.config && teeinblueCampaign.config.maps_api_key;
        if (!m || !k || String(k).indexOf('pk.') !== 0) return u;
        return 'https://api.mapbox.com/styles/v1/' + m[1] + '/' + m[2] + '/tiles/256/' + m[3] + '/' + m[4] + '/' + m[5] + '@2x?access_token=' + k;
      };
    }
  }
  function karteIn(dlg){ return karten.filter(function(m){ return m._container && dlg.contains(m._container); }).pop(); }
  var KARTE_ZOOM = ZIEL_ZOOM + 1;  /* Kacheln sind 512 px: Kartenzoom = Kachelstufe + 1 */
  function heranzoomen(dlg, versuch){
    if (!dlg.isConnected || !dlg.querySelector('.vm--modal')) return;
    var m = karteIn(dlg);
    if (m) {
      var los = function(){ try { if (m._container && m._container.isConnected && m.getZoom() < KARTE_ZOOM) m.setZoom(KARTE_ZOOM, { animate: false }); } catch (e) {} };
      if (m._animatingZoom) m.once('zoomend', function(){ setTimeout(los, 30); }); else los();
      return;
    }
    /* Rückfall ohne Kartenzugriff: Plus-Knopf, aber nie während einer Animation */
    var z = kartenZoom(dlg), plus = dlg.querySelector('.leaflet-control-zoom-in');
    if (z == null || !plus) { if ((versuch || 0) < 6) setTimeout(function(){ heranzoomen(dlg, (versuch || 0) + 1); }, 300); return; }
    if (z >= ZIEL_ZOOM) return;
    if (dlg.querySelector('.leaflet-zoom-anim, .leaflet-pan-anim')) { setTimeout(function(){ heranzoomen(dlg, 7); }, 300); return; }
    plus.click();
    setTimeout(function(){ heranzoomen(dlg, 7); }, 420);
  }
  D.addEventListener('pointerdown', function(e){ if (e.target.closest && e.target.closest('.tee-field-maps')) karteHaken(); }, true);
  D.addEventListener('click', function(e){
    var li = e.target.closest && e.target.closest('.tee-maps__searcher-item, .tee-maps__searcher-item-content');
    if (li) { var dlg = li.closest('.vm--container'); if (dlg) setTimeout(function(){ heranzoomen(dlg, 0); }, 900); return; }
    if (e.target.closest && e.target.closest('.tee-campaign, .vm--container')) setTimeout(uebersetzeDialoge, 350);
    /* Welle 0: Ort übernommen -> Titel nachziehen (Ortsname ändert oft nur einen Textknoten,
       den der childList-Beobachter nicht sieht) */
    if (e.target.closest && e.target.closest('.vm--container')) { setTimeout(takt, 500); setTimeout(takt, 1600); }
  }, true);
  D.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' || !e.target.closest || !e.target.closest('.tee-maps')) return;
    var dlg = e.target.closest('.vm--container'); if (dlg) setTimeout(function(){ heranzoomen(dlg, 0); }, 900);
  }, true);

  /* ================= Welle 0: Stadt als Titel (27.09.2026) ================= */
  /* Das Titelfeld der Stadtkarten ist leer – KÖLN ist nur Platzhalter bzw. Standardtext.
     Nach der Ortswahl blieb deshalb KÖLN auf dem Poster. Solange der Kunde den Titel nicht
     selbst geändert hat, schreiben wir den gewählten Ort hinein – wie ein Nutzer (value +
     input-Event, siehe setzeWert). Merker 'lr7-titel-auto' in der Sitzung: nur ein Titel,
     der noch leer ist oder genau unserem letzten Vorschlag entspricht, wird ersetzt. */
  var TITEL_AUTO = 'lr7-titel-auto', ortZuletzt = null;
  function titelFeld(c){
    var f = $$('.tee-field', c).filter(function(f){ return /tee-field--text/.test(f.className) && /^(titel|title|überschrift)/.test(feldName(f)); })[0];
    return f ? f.querySelector('input.tee__input, textarea') : null;
  }
  function stadtAus(ort){
    var teile = String(ort || '').split(',').map(function(t){ return t.trim(); }).filter(Boolean);
    for (var i = 0; i < teile.length; i++) {
      if (!/\d/.test(teile[i])) return teile[i];
      var m = teile[i].match(/^\d{4,5}\s+(\D+)$/); if (m) return m[1].trim();
    }
    return '';
  }
  function titelPflegen(c){
    /* nur Stadtkarten: bei Sternenkarten mit Zusatzkarte (Himmel & Erde) ist der Titel kein Ortsname */
    var mf = c.querySelector('.tee-field--maps .tee-field-maps'); if (!mf || c.querySelector('.tee-field--star_maps')) return;
    var ot = (mf.textContent || '').replace(/\s+/g, ' ').trim();
    if (/suchen|search/i.test(ot)) ot = '';
    if (ortZuletzt === null) { ortZuletzt = ot; return; }   /* erster Blick: nur merken */
    if (ot === ortZuletzt) return;
    ortZuletzt = ot;
    var stadt = stadtAus(ot), i = titelFeld(c); if (!stadt || !i) return;
    var auto = ''; try { auto = sessionStorage.getItem(TITEL_AUTO) || ''; } catch (e) {}
    var jetzt = String(i.value || '').trim();
    if (jetzt && jetzt !== auto) return;                    /* eigener Titel des Kunden bleibt */
    var ph = String(i.placeholder || '').trim();
    var neu = (!ph || ph === ph.toLocaleUpperCase('de-DE')) ? stadt.toLocaleUpperCase('de-DE') : stadt;
    if (i.maxLength > 0) neu = neu.slice(0, i.maxLength);
    try { sessionStorage.setItem(TITEL_AUTO, neu); } catch (e) {}
    if (i.value !== neu) setzeWert(i, neu);
  }

  /* =====================================================================
     Gestalter 9 (28.09.2026, Lucas Nachbesserung):
     – Ebenen-Vorschau: das Poster liegt als einzelne Ebenen auf der Bühne. So kann sich beim
       Designwechsel das Sternbild hereindrehen und die Karte hereinfliegen, beim Tippen zoomt
       die Vorschau an die Textstelle, und eine neue Uhrzeit dreht den Himmel wirklich weiter.
     – Mini-Vorschauen: jede Farbe zeigt EUREN Ort bzw. EUREN Himmel in dieser Farbe,
       jeder Rahmen euer Poster in diesem Rahmen, jede Größe das Poster über einem Sofa.
     – Lupe: Poster bildschirmfüllend, doppelt tippen oder mit zwei Fingern vergrößern.
     – Film „Dein Poster in Szene“ nach dem Format, danach Prüfen mit Bestätigung.
     Regeln bleiben: teeinblue-DOM nie umbauen, nur Labels anklicken, nur transform/opacity/clip-path animieren.
     ===================================================================== */
  var AUS9 = 'cubic-bezier(.16,1,.3,1)', WISCH9 = 'cubic-bezier(.77,0,.18,1)';
  var FEDER9 = 'linear(0, 0.037, 0.127, 0.245, 0.376, 0.502, 0.623, 0.729, 0.819, 0.891, 0.946, 0.987, 1.016, 1.034, 1.044, 1.048, 1.047, 1.044, 1.038, 1.032, 1.026, 1.02, 1.015, 1.01, 1.006, 1.003, 1.001, 1, 0.999, 0.998, 0.998, 0.998, 0.998, 0.998, 0.998, 0.999, 1)';
  try { if (!(window.CSS && CSS.supports && CSS.supports('animation-timing-function', FEDER9))) FEDER9 = 'cubic-bezier(.34,1.3,.64,1)'; } catch (e) { FEDER9 = 'cubic-bezier(.34,1.3,.64,1)'; }
  var NS = 'http://www.w3.org/2000/svg', XL = 'http://www.w3.org/1999/xlink';
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function gross(s){ s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function vbVon(a){ var v = (a.getAttribute('viewBox') || '0 0 390 517').split(/[\s,]+/).map(Number); return { w: v[2] || 390, h: v[3] || 517 }; }
  function lidVon(f){ return ((String(f.className || '').match(/tee-field--(layer-\d+)/) || [])[1]) || ''; }

  /* ---------- Kampagnendaten (Vorlagen für die Farb-Vorschauen) ---------- */
  var K = null, kWarte = [], kLaeuft = false;
  function kampagne(fertig){
    if (K) { if (fertig) fertig(K); return; }
    if (fertig) kWarte.push(fertig);
    if (kLaeuft) return; kLaeuft = true;
    var u = performance.getEntriesByType('resource').map(function(r){ return r.name; }).filter(function(n){ return /merchant\/campaigns\/.*\.json/.test(n); })[0];
    var id = produktJson && produktJson.id, shop = window.Shopify && window.Shopify.shop;
    if (!u && id && shop) u = 'https://api.teeinblue.com/api/merchant/campaigns/' + id + '.json?shop=' + shop;
    if (!u) { kLaeuft = false; setTimeout(function(){ kampagne(); }, 900); return; }
    fetch(u, { credentials: 'omit' }).then(function(r){ return r.json(); }).then(function(j){
      K = { artworks: j.artworks || [] };
      var w = kWarte; kWarte = []; w.forEach(function(f){ try { f(K); } catch (e) {} });
      farbPanel(true);
    }).catch(function(){ kLaeuft = false; });
  }
  function kArtwork(){
    var a = artwork(); if (!K || !a) return null;
    var id = +String(a.id).replace(/\D/g, '');
    return K.artworks.filter(function(x){ return x.id === id; })[0] || K.artworks[0] || null;
  }

  /* ---------- Ebenen-Vorschau ---------- */
  function ebenenVon(a){ return [].filter.call(a.children, function(c){ return c.id && c.id.indexOf('artwork-layer--') === 0; }); }
  function ebenenSig(a){ return a ? a.id + ':' + ebenenVon(a).map(function(c){ return c.id; }).join(',') + sternSig() : ''; }
  /* Sternenhimmel: teeinblue zeichnet ihn als Bild in ein eigenes <svg>, das die Karte per <use> einbindet.
     Safari verzerrt eine solche verschachtelte Kopie zum Oval. Deshalb kopieren wir die Sternen-Ebene
     selbst und setzen das Himmelsbild direkt ein – und bauen neu, sobald teeinblue den Himmel neu rechnet. */
  function sternBild(){ return D.querySelector('svg[id$="-star-maps-svg"] image'); }
  function sternSig(){ var i = sternBild(); if (!i) return ''; var h = i.getAttribute('href') || i.getAttribute('xlink:href') || ''; return '|s' + h.length + h.slice(-24); }
  /* teeinblue tauscht beim Neurechnen nur das Bild im Sternen-<svg> – ein kleiner Beobachter nur dort */
  var sternMo = null, sternEl = null;
  function sternBeobachten(){
    var el = D.querySelector('svg[id$="-star-maps-svg"]'); if (!el || el === sternEl) return;
    sternEl = el; if (sternMo) sternMo.disconnect();
    sternMo = new MutationObserver(function(){ takt(); });
    sternMo.observe(el, { attributes: true, childList: true, subtree: true, attributeFilter: ['href', 'xlink:href'] });
  }
  function sternKlon(c){
    var k = c.cloneNode(true), u = k.querySelector('.tee-layer-star-maps use') || k.querySelector('use');
    var ref = u && (u.getAttribute('href') || u.getAttributeNS(XL, 'href'));
    var src = ref && D.getElementById(ref.slice(1)); if (!src) return null;
    var w = +u.getAttribute('width') || 0, h = +u.getAttribute('height') || 0, x = +u.getAttribute('x') || 0, y = +u.getAttribute('y') || 0;
    var vb = (src.getAttribute('viewBox') || '0 0 400 400').split(/[\s,]+/).map(Number);
    var sc = Math.max(w / vb[2], h / vb[3]);
    var g = D.createElementNS(NS, 'g');
    g.setAttribute('transform', 'translate(' + (x + (w - vb[2] * sc) / 2) + ' ' + y + ') scale(' + sc + ') translate(' + (-vb[0]) + ' ' + (-vb[1]) + ')');
    [].forEach.call(src.childNodes, function(n){ if (n.nodeType === 1) g.appendChild(n.cloneNode(true)); });
    u.parentNode.replaceChild(g, u);
    $$('[id]', k).forEach(function(e){ e.removeAttribute('id'); });
    return k;
  }
  function ebenenTyp(c, n){
    if (/tee-layer-text/.test(c.getAttribute('class') || '')) return 'text';
    if (c.querySelector('.tee-layer-star-maps')) return 'stern';
    if (c.querySelector('[id$="-maps"]')) return 'karte';
    return n === 0 ? 'grund' : 'bild';
  }
  function schichtenSvg(ohne){
    var a = artwork(); if (!a) return null;
    var vb = vbVon(a);
    var s = D.createElementNS(NS, 'svg'); s.setAttribute('viewBox', '0 0 ' + vb.w + ' ' + vb.h); s.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    s.setAttribute('data-sig', ebenenSig(a));
    ebenenVon(a).forEach(function(c, n){
      var lid = c.id.replace('artwork-layer--', ''), typ = ebenenTyp(c, n);
      if (typ === 'stern') { var kl = sternKlon(c); if (kl) { kl.removeAttribute('id'); kl.setAttribute('data-lid', lid); kl.setAttribute('data-typ', 'stern'); if (ohne && ohne === lid) kl.setAttribute('data-ersetzen', '1'); s.appendChild(kl); return; } }
      var u = D.createElementNS(NS, 'use'); u.setAttribute('href', '#' + c.id); u.setAttributeNS(XL, 'xlink:href', '#' + c.id);
      u.setAttribute('data-lid', lid); u.setAttribute('data-typ', ebenenTyp(c, n));
      if (ohne && ohne === lid) u.setAttribute('data-ersetzen', '1');
      s.appendChild(u);
    });
    return s;
  }
  function schichten(){ var sv = $('.lr7-live .lr7-papier svg[data-sig]'); return sv ? $$('[data-lid]', sv) : []; }
  /* Drehpunkt einer Ebene: Mitte ihres Inhalts (getBBox der Kopie = Lage im Poster) */
  function mitteVon(u){
    var bb = null; try { bb = u.getBBox(); } catch (e) {}
    if (bb && bb.width) return { cx: bb.x + bb.width / 2, cy: bb.y + bb.height / 2, bb: bb };
    var a = artwork(), vb = a ? vbVon(a) : { w: 390, h: 517 }; return { cx: vb.w / 2, cy: vb.h / 2, bb: null };
  }
  function ursprung(u){ var m = mitteVon(u); u.style.transformBox = 'view-box'; u.style.transformOrigin = m.cx.toFixed(1) + 'px ' + m.cy.toFixed(1) + 'px'; return m; }

  /* Enthüllung: 'design' (neues Design, groß), 'farbe' (andere Farbe, kurz) */
  function enthuellen(art){
    if (RUHIG || D.hidden) return false;
    var us = schichten(); if (!us.length) return false;
    var kurz = art !== 'design', n = 0;
    us.forEach(function(u){
      ursprung(u); var typ = u.getAttribute('data-typ');
      u.getAnimations().forEach(function(x){ x.cancel(); });
      if (typ === 'stern') u.animate(kurz
        ? [{ transform: 'rotate(-80deg) scale(.93)', opacity: .25 }, { transform: 'none', opacity: 1 }]
        : [{ transform: 'rotate(-160deg) scale(.76)', opacity: 0 }, { opacity: 1, offset: .28 }, { transform: 'none', opacity: 1 }],
        { duration: kurz ? 1150 : 1800, easing: 'cubic-bezier(.12,.75,.18,1)', fill: 'backwards', delay: kurz ? 0 : 160 });
      else if (typ === 'karte') u.animate(kurz
        ? [{ opacity: .2, transform: 'scale(1.1)' }, { opacity: 1, transform: 'none' }]
        : [{ transform: 'scale(1.6) rotate(-5deg)', opacity: 0 }, { opacity: 1, offset: .32 }, { transform: 'none', opacity: 1 }],
        { duration: kurz ? 850 : 1600, easing: AUS9, fill: 'backwards', delay: kurz ? 0 : 110 });
      else if (typ === 'text') u.animate([{ transform: 'translateY(' + (kurz ? 7 : 18) + 'px)', opacity: 0 }, { transform: 'none', opacity: 1 }],
        { duration: kurz ? 520 : 820, easing: AUS9, fill: 'backwards', delay: (kurz ? 220 : 700) + (n++) * 120 });
      else if (typ === 'grund') { if (!kurz) u.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 520, fill: 'backwards' }); }
      else u.animate([{ opacity: 0 }, { opacity: 1 }], { duration: kurz ? 480 : 820, fill: 'backwards', delay: kurz ? 120 : 460 });
    });
    return true;
  }
  /* Abgang vor dem Wechsel auf ein anderes Design (andere Produktseite) */
  function abgang(){
    if (RUHIG) return 0;
    var us = schichten(); if (!us.length) return 0;
    us.forEach(function(u){
      ursprung(u); var t = u.getAttribute('data-typ');
      if (t === 'stern') u.animate([{ transform: 'none', opacity: 1 }, { transform: 'rotate(130deg) scale(.82)', opacity: 0 }], { duration: 440, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' });
      else if (t === 'karte') u.animate([{ transform: 'none', opacity: 1 }, { transform: 'scale(.78)', opacity: 0 }], { duration: 440, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' });
      else u.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 320, fill: 'forwards' });
    });
    return 360;
  }
  /* Momentaufnahme des alten Zustands (für den Farbwechsel darüberblenden) */
  function schnappschuss(){
    var a = artwork(), p = $('.lr7-live .lr7-papier'); if (!a || !p || RUHIG) return null;
    var k = a.cloneNode(true);
    k.removeAttribute('id'); k.setAttribute('class', 'lr9-schnapp'); k.setAttribute('preserveAspectRatio', 'xMidYMid slice'); k.setAttribute('aria-hidden', 'true');
    $$('[id]', k).forEach(function(e){ e.removeAttribute('id'); });
    p.appendChild(k); return k;
  }
  function nachWechsel(sigAlt, mindest, fertig){
    var n = 0, t0 = Date.now();
    (function schau(){
      n++; var s = ebenenSig(artwork());
      if ((s && s !== sigAlt && Date.now() - t0 >= mindest) || n > 14) { B.zeichne(true); setTimeout(fertig, 70); }
      else setTimeout(schau, 110);
    })();
  }

  /* Sternenhimmel: neue Uhrzeit/neues Datum dreht den Himmel (15° je Stunde) */
  var zeitAlt = null;
  function sternZeit(){ var i = $('.tee-campaign .tee-field--star_maps input[type="datetime-local"]'); var d = i && i.value ? new Date(i.value) : null; return d && !isNaN(d) ? d : null; }
  function sternZeitPruefen(){
    var neu = sternZeit(); if (!neu) return;
    if (zeitAlt && neu.getTime() !== zeitAlt.getTime()) himmelDrehen((neu - zeitAlt) / 3600000);
    zeitAlt = neu;
  }
  function himmelDrehen(stunden){
    if (RUHIG) return;
    var grad = ((stunden * 15.041) % 360 + 540) % 360 - 180;
    if (Math.abs(grad) < 4) grad = grad < 0 ? -18 : 18;
    var alt = sternSig(), n = 0;
    (function warte(){
      if (sternSig() === alt && ++n < 25) return setTimeout(warte, 90);
      B.zeichne(true);
      setTimeout(function(){
        var u = schichten().filter(function(x){ return x.getAttribute('data-typ') === 'stern'; })[0]; if (!u) return;
        ursprung(u); u.getAnimations().forEach(function(x){ x.cancel(); });
        u.animate([{ transform: 'rotate(' + (-grad).toFixed(1) + 'deg)' }, { transform: 'none' }], { duration: 1600, easing: 'cubic-bezier(.3,.7,.1,1)' });
      }, 30);
    })();
  }
  /* Karte: neuer Ort -> die Karte fliegt aus der Höhe herein */
  var ortAlt = null;
  function kartenOrt(){ var a = artwork(), im = a && a.querySelector('[id$="-maps"] image'); var u = im && (im.getAttribute('href') || im.getAttribute('xlink:href') || ''); var m = u && u.match(/\/static\/([-\d.]+,[-\d.]+),/); return m ? m[1] : null; }
  function kartenOrtPruefen(){
    var o = kartenOrt(); if (!o) return;
    if (ortAlt && o !== ortAlt && !RUHIG && !B.uebernahme) {
      setTimeout(function(){
        var u = schichten().filter(function(x){ return x.getAttribute('data-typ') === 'karte'; })[0]; if (!u) return;
        ursprung(u); u.getAnimations().forEach(function(x){ x.cancel(); });
        u.animate([{ transform: 'scale(1.7)', opacity: .1 }, { opacity: 1, offset: .35 }, { transform: 'none', opacity: 1 }], { duration: 1500, easing: AUS9 });
        schichten().filter(function(x){ return x.getAttribute('data-typ') === 'text'; }).forEach(function(t, i){ ursprung(t); t.animate([{ transform: 'translateY(10px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 700, delay: 500 + i * 110, easing: AUS9, fill: 'backwards' }); });
      }, 250);
    }
    ortAlt = o;
  }

  /* ---------- Beim Tippen: Vorschau zoomt an die Textstelle ---------- */
  var zoomLid = null;
  function textZoom(lid){
    var z = $('.lr7-live .lr9-zoom'), p = $('.lr7-live .lr7-papier');
    zoomLid = lid;
    if (!z || !p) return;
    if (!lid || RUHIG || B.ansicht !== 'live') { z.style.transform = ''; D.body.classList.remove('lr9-nah'); return; }
    var u = p.querySelector('[data-lid="' + lid + '"]'); if (!u) { z.style.transform = ''; return; }
    var m = mitteVon(u); if (!m.bb) return;
    var a = artwork(), vb = vbVon(a);
    var alt = z.style.transform; z.style.transition = 'none'; z.style.transform = 'none';
    var pr = p.getBoundingClientRect(), zr = z.getBoundingClientRect();
    z.style.transform = alt; void z.offsetWidth; z.style.transition = '';
    var s = Math.max(pr.width / vb.w, pr.height / vb.h), ox = pr.left + (pr.width - vb.w * s) / 2, oy = pr.top + (pr.height - vb.h * s) / 2;
    var cx = ox + m.cx * s - zr.left, cy = oy + m.cy * s - zr.top;
    var tb = Math.max(m.bb.width * s, 40);
    var f = Math.max(1.35, Math.min(2.6, zr.width * .84 / tb));
    z.style.transformOrigin = '0 0';
    z.style.transform = 'translate(' + (zr.width / 2 - cx * f).toFixed(1) + 'px,' + (zr.height * .5 - cy * f).toFixed(1) + 'px) scale(' + f.toFixed(3) + ')';
    D.body.classList.add('lr9-nah');
  }
  D.addEventListener('focusin', function(e){
    if (!D.body.classList.contains('lr-gestalten') || !e.target.closest) return;
    var f = e.target.closest('.tee-campaign .tee-field'); if (!f) return;
    var tipp = e.target.matches('input.tee__input, textarea, input[type=text]');
    if (HANDY && tipp) { D.body.classList.add('lr9-tippt'); clearTimeout(B.tTipp); }
    var lid = /tee-field--text|tee-field--textarea/.test(f.className) ? lidVon(f) : null;
    clearTimeout(B.tZoom);
    B.tZoom = setTimeout(function(){ B.zeichne(true); setTimeout(function(){ textZoom(lid); }, 60); }, HANDY && tipp ? 380 : 40);
  }, true);
  D.addEventListener('focusout', function(e){
    if (!D.body.classList.contains('lr-gestalten')) return;
    clearTimeout(B.tTipp);
    B.tTipp = setTimeout(function(){
      var a = D.activeElement; if (a && a.closest && a.closest('.tee-campaign .tee-field') && a.matches('input, textarea, select')) return;
      D.body.classList.remove('lr9-tippt'); textZoom(null); setTimeout(function(){ B.zeichne(true); }, 340);
    }, 180);
  }, true);
  /* Tinte: das Getippte leuchtet an seiner Stelle kurz auf */
  var tinteT = 0;
  D.addEventListener('input', function(e){
    if (RUHIG || !e.target.closest || !D.body.classList.contains('lr-gestalten')) return;
    var f = e.target.closest('.tee-campaign .tee-field'); if (!f || Date.now() - tinteT < 260) return; tinteT = Date.now();
    var lid = lidVon(f); if (!lid) return;
    setTimeout(function(){
      var u = $('.lr7-live .lr7-papier [data-lid="' + lid + '"]'); if (!u) return;
      ursprung(u); u.animate([{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(1.06)', opacity: .72, offset: .35 }, { transform: 'scale(1)', opacity: 1 }], { duration: 520, easing: AUS9 });
    }, 120);
  }, true);

  /* ---------- Mini-Vorschauen: Farben ---------- */
  function farbQuelle(){
    var c = camp(); if (!c) return null;
    var f = $$('.tee-field--clipart', c).filter(function(x){ return /farbe|color/i.test(feldName(x)) && x.style.display !== 'none'; })[0];
    if (f) {
      var rr = $$('input[type=radio]', f);
      if (rr.length > 1) return { art: 'clipart', feld: f, lid: lidVon(f), titel: gross(feldName(f)) || 'Farbe',
        wert: (rr.filter(function(r){ return r.checked; })[0] || {}).value || '',
        optionen: rr.map(function(r){
          var l = f.querySelector(idWahl(r.id)), im = l && l.querySelector('img');
          var src = im ? (im.getAttribute('data-src') || im.getAttribute('src') || '') : '';
          if (/^data:/.test(src)) src = '';
          return { wert: r.value, text: ((l && (l.getAttribute('data-title') || l.textContent)) || r.value).trim(), bild: src.replace('_thumbnail.', '_large.') };
        }),
        setze: function(v){ var z = rr.filter(function(r){ return r.value === v; })[0]; if (!z || z.checked) return false; var l = f.querySelector(idWahl(z.id)); (l || z).click(); return true; } };
    }
    var s = vorlageWahl();
    if (s && s.optionen.length > 1 && s.optionen.length <= 12 && !$('.lr7-designs [data-lr-design]') && !$('[data-lr-designs] .lr-designs')) { s.titel = gross(feldName(s.feld)) || 'Farbe'; return s; }
    return null;
  }
  function kVorlage(o){
    var aw = kArtwork(); if (!aw) return null;
    return (aw.data || []).filter(function(t){ return t.id === o.wert || String(t.id).replace('template-', '') === String(o.wert).replace('template-', '') || (t.name || '').trim() === o.text; })[0] || null;
  }
  function mapboxMini(stil){
    var a = artwork(), im = a && a.querySelector('[id$="-maps"] image');
    var u = im && (im.getAttribute('href') || im.getAttribute('xlink:href') || '');
    if (!u || u.indexOf('api.mapbox.com') < 0) return '';
    var s = String(stil || '').replace('mapbox://styles/', '');
    if (s) u = u.replace(/styles\/v1\/[^/]+\/[^/]+\/static\//, 'styles/v1/' + s + '/static/');
    return u.replace(/\/static\/([-\d.]+),([-\d.]+),([\d.]+)((?:,[\d.]+)*)\/(\d+)x(\d+)(@2x)?/, function(_, lo, la, z, rest, w, h){
      var f = 260 / +w; return '/static/' + lo + ',' + la + ',' + Math.max(0, +z + Math.log(f) / Math.LN2).toFixed(2) + '/' + Math.round(+w * f) + 'x' + Math.round(+h * f);
    });
  }
  function bildEl(href, x, y, w, h, par){
    var i = D.createElementNS(NS, 'image'); i.setAttribute('href', href); i.setAttributeNS(XL, 'xlink:href', href);
    i.setAttribute('x', x); i.setAttribute('y', y); i.setAttribute('width', w); i.setAttribute('height', h); i.setAttribute('preserveAspectRatio', par || 'none');
    return i;
  }
  function miniPoster(q, o){
    var a = artwork(); if (!a) return null;
    var vb = vbVon(a);
    if (q.art === 'clipart') {
      var s = schichtenSvg(q.lid); if (!s) return null;
      var ers = s.querySelector('[data-ersetzen]');
      if (ers) {
        var orig = D.getElementById('artwork-layer--' + q.lid), bb = null; try { bb = orig && orig.getBBox(); } catch (e) {}
        if (o.bild) s.replaceChild(bildEl(o.bild, bb ? bb.x : 0, bb ? bb.y : 0, bb ? bb.width : vb.w, bb ? bb.height : vb.h), ers);
        else s.removeChild(ers);
      }
      return s;
    }
    var t = kVorlage(o), aw = kArtwork(); if (!t || !aw) return null;
    var k = vb.w / (aw.width || 3615);
    var sv = D.createElementNS(NS, 'svg'); sv.setAttribute('viewBox', '0 0 ' + vb.w + ' ' + vb.h); sv.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    var texte = $$(':scope > g.tee-layer-text', a), ti = 0, farbe = [];
    (t.layers || []).forEach(function(l){
      if (l.type === 'static-photo' && l.url && l.url.indexOf('placehold') < 0) sv.appendChild(bildEl('https://cdn.teeinblue.com/' + l.url + (l.url.indexOf('?') > 0 ? '' : '?v=1'), l.left * k, l.top * k, l.width * k, l.height * k));
      else if (l.type === 'maps') { var mu = mapboxMini(l.maps_default_style); if (mu) sv.appendChild(bildEl(mu, l.left * k, l.top * k, l.width * k, l.height * k, 'xMidYMid slice')); }
      else if (l.type === 'text') farbe.push(l.color);
    });
    texte.forEach(function(g, i){
      var kl = g.cloneNode(true); $$('[id]', kl).forEach(function(e){ e.removeAttribute('id'); }); kl.removeAttribute('id');
      if (farbe[i]) $$('text', kl).forEach(function(tx){ tx.setAttribute('fill', farbe[i]); });
      sv.appendChild(kl);
    });
    if (!sv.childNodes.length && t.url) sv.appendChild(bildEl('https://cdn.teeinblue.com/' + t.url, 0, 0, vb.w, vb.h, 'xMidYMid slice'));
    return sv;
  }
  var farbSigAlt = '', tippZuletzt = 0;
  D.addEventListener('input', function(e){ if (e.target.closest && e.target.closest('.tee-campaign')) tippZuletzt = Date.now(); }, true);
  function farbPanel(neu){
    var halter = $('.lr-halter'); if (!halter) return;
    var box = $('.lr9-farben'), q = farbQuelle();
    var zeigen = S.reiter === 'gestalten' && D.body.classList.contains('lr-gestalten');
    if (!q) { if (box) box.hidden = true; return; }
    if (q.art !== 'clipart') kampagne();
    if (!box) {
      box = D.createElement('div'); box.className = 'lr-gk-hinweis lr9-farben';
      var cc = camp();
      if (cc && cc.parentNode && halter.contains(cc)) cc.parentNode.insertBefore(box, cc.nextSibling);
      else { var u = halter.querySelector('.lr-gk-unter'); if (!u) return; u.parentNode.insertBefore(box, u.nextSibling); }
      box.addEventListener('click', function(e){ var b = e.target.closest('[data-lr9-farbe]'); if (b) waehleFarbe(b.getAttribute('data-lr9-farbe')); });
    }
    var titelWert = ((titelFeld(camp()) || {}).value || '');
    var sig = q.art + '|' + q.optionen.map(function(o){ return o.wert; }).join(',') + '|' + (kartenOrt() || '') + '|' + (K ? 1 : 0) + '|' + (q.art === 'clipart' ? '' : titelWert) + '|' + ebenenSig(artwork());
    if ((sig !== farbSigAlt || neu === true) && (Date.now() - tippZuletzt > 700 || !box.childNodes.length)) {
      farbSigAlt = sig;
      box.innerHTML = '<p class="lr7-titel">' + esc(q.titel) + '</p><div class="lr9-fa-reihe">' + q.optionen.map(function(o){
        return '<button type="button" class="lr9-fa" data-lr9-farbe="' + esc(o.wert) + '" aria-label="' + esc(o.text) + '"><span class="lr9-fa-mini"></span><b>' + esc(o.text) + '</b></button>';
      }).join('') + '</div>';
      $$('.lr9-fa', box).forEach(function(b, i){
        var sv = miniPoster(q, q.optionen[i]), m = b.querySelector('.lr9-fa-mini');
        if (sv) m.appendChild(sv); else if (q.optionen[i].bild) m.style.backgroundImage = 'url(' + q.optionen[i].bild + ')';
        b.style.setProperty('--i', i);
      });
      if (!B.farbenGezeigt && zeigen) { B.farbenGezeigt = true; box.classList.add('lr9-neu'); }
      var an = box.querySelector('.lr9-fa.an'); if (an) an.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
    $$('.lr9-fa', box).forEach(function(b){ b.classList.toggle('an', b.getAttribute('data-lr9-farbe') === q.wert); });
    q.feld.classList.add('lr7-select-ersetzt');
    box.hidden = !zeigen;
  }
  /* teeinblue verliert beim Wechsel der Ausführung (Rahmen) die gewählte Vorlage – dann fehlen sogar die
     Eingabefelder und das Poster springt auf die erste Farbe. Wir merken uns die Wahl und stellen sie wieder her. */
  function vorlageHalten(){
    var frisch = Date.now() - (B.ausfZeit || 0) < 6000;
    var s = vorlageWahl();
    if (s && s.optionen.length) {
      if (s.wert && !frisch) B.vorlage = s.wert;
      else if (B.vorlage && s.wert !== B.vorlage && (frisch || !s.wert) && s.optionen.some(function(o){ return o.wert === B.vorlage; })) s.setze(B.vorlage);
    }
    var q = farbQuelle();
    if (q && q.art === 'clipart') {
      if (q.wert && !frisch) B.clip = q.wert;
      else if (B.clip && q.wert !== B.clip && frisch) q.setze(B.clip);
    }
  }
  function waehleFarbe(v){
    var q = farbQuelle(); if (!q || q.wert === v) return;
    B.angefasst = true;
    if (q.art === 'clipart') B.clip = v; else B.vorlage = v;
    var sigAlt = ebenenSig(artwork()), snap = schnappschuss();
    q.setze(v);
    $$('.lr9-fa').forEach(function(b){ b.classList.toggle('an', b.getAttribute('data-lr9-farbe') === v); });
    nachWechsel(q.art === 'clipart' ? '§' : sigAlt, q.art === 'clipart' ? 420 : 0, function(){
      enthuellen('farbe');
      if (snap) { var sn = snap.isConnected ? snap : null; if (!sn) { var p = $('.lr7-live .lr7-papier'); if (p) { p.appendChild(snap); sn = snap; } }
        if (sn) sn.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 700, easing: 'ease-out', fill: 'forwards' }).finished.then(function(){ sn.remove(); }, function(){ sn.remove(); }); }
      farbPanel(true);
    });
  }

  /* ---------- Mini-Vorschauen: Größen (Poster über einem Sofa, im echten Verhältnis) ---------- */
  var RFARBE = { schwarz: '#1b1b1b', weiss: '#f5f3ef', eiche: '#c49a62', walnuss: '#5a3a24', ohne: '#fbfaf8', leinwand: '#f4f1ec' };
  function wandMini(b, h, au, an){
    /* 1 Einheit = 2,5 cm; Sofa 210 cm breit */
    var W = 132, pb = b / 2.5, ph = h / 2.5, x = (W - pb) / 2, y = 44 - ph;
    var rf = RFARBE[au] || '#1b1b1b', rand = (au === 'ohne' || au === 'leinwand') ? 0 : 1.2;
    return '<svg viewBox="0 0 ' + W + ' 80" aria-hidden="true"><rect x="0" y="0" width="' + W + '" height="80" fill="#EFEBE5"/>' +
      '<rect x="0" y="66" width="' + W + '" height="14" fill="#E3DDD3"/>' +
      '<path d="M24 66 v-10 q0-6 6-6 h72 q6 0 6 6 v10 z" fill="#D8CFC2"/><rect x="21" y="54" width="7" height="13" rx="3" fill="#CFC5B7"/><rect x="104" y="54" width="7" height="13" rx="3" fill="#CFC5B7"/>' +
      '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + pb.toFixed(1) + '" height="' + ph.toFixed(1) + '" fill="' + rf + '"' + (au === 'weiss' || au === 'ohne' ? ' stroke="#CFC8BD" stroke-width=".5"' : '') + '/>' +
      '<rect x="' + (x + rand).toFixed(1) + '" y="' + (y + rand).toFixed(1) + '" width="' + (pb - 2 * rand).toFixed(1) + '" height="' + (ph - 2 * rand).toFixed(1) + '" fill="' + (an ? '#FFFFFF' : '#FBFAF8') + '"/>' +
      '<rect x="' + (x + rand + pb * .12).toFixed(1) + '" y="' + (y + rand + ph * .1).toFixed(1) + '" width="' + (pb * .76 - 2 * rand).toFixed(1) + '" height="' + (ph * .62).toFixed(1) + '" fill="' + (an ? '#2A2622' : '#BDB6AB') + '" opacity=".85"/></svg>';
  }
  function groessenPanel(){
    var halter = $('.lr-halter'), c = camp(); if (!halter || !c) return;
    var rr = $$('.tee-option--size .tee-radio', c), box = $('.lr9-groessen');
    var zeigen = S.reiter === 'produkt' && D.body.classList.contains('lr-gestalten');
    if (!POSTER || rr.length < 2) { if (box) box.hidden = true; return; }
    if (!box) {
      box = D.createElement('div'); box.className = 'lr-gk-hinweis lr9-groessen';
      var rw = $('.lr7-rahmenwahl');
      if (rw && rw.parentNode) rw.parentNode.insertBefore(box, rw.nextSibling); else { var u = halter.querySelector('.lr-gk-unter'); if (!u) return; u.parentNode.insertBefore(box, u.nextSibling); }
      box.addEventListener('click', function(e){
        var k = e.target.closest('[data-gr]'); if (!k) return;
        var r = $$('.tee-option--size .tee-radio', camp())[+k.getAttribute('data-gr')]; if (!r || r.classList.contains('active')) return;
        B.angefasst = true; B.ausfZeit = Date.now();
        (r.querySelector('label') || r).click();
        $$('.lr9-gr', box).forEach(function(b){ b.classList.toggle('an', b === k); });
        var mass = k.querySelector('b'); if (mass && !RUHIG) mass.animate([{ transform: 'scale(1.18)' }, { transform: 'none' }], { duration: 520, easing: FEDER9 });
        setTimeout(function(){ pflegePreise(); B.zeichne(true); groessenPanel(); }, 260);
      });
    }
    var tab = preisTabelle(ausfuehrungen().filter(function(x){ return x.aktiv; })[0]) || {}, au = ausfuehrung();
    var h = '<p class="lr7-titel">Größe <small>im Verhältnis zu einem 2-m-Sofa</small></p><div class="lr9-gr-reihe">' + rr.map(function(r, i){
      var t = (r.textContent || '').replace(/\s+/g, ' '), m = t.match(/(\d{2,3})\s*[x×]\s*(\d{2,3})/); if (!m) return '';
      var b = Math.min(+m[1], +m[2]), hh = Math.max(+m[1], +m[2]), an = r.classList.contains('active');
      var p = tab[norm(m[1] + 'x' + m[2] + 'cm')]; if (p == null) p = tab[norm(m[2] + 'x' + m[1] + 'cm')];
      return '<button type="button" data-gr="' + i + '" class="lr9-gr' + (an ? ' an' : '') + '">' + wandMini(b, hh, au, an) + '<b>' + b + ' × ' + hh + ' cm</b><small>' + (p != null ? geld(p) : '') + '</small></button>';
    }).join('') + '</div>';
    if (box.getAttribute('data-stand') !== h) { box.innerHTML = h; box.setAttribute('data-stand', h); }
    c.classList.add('lr9-groesse-ersetzt');
    box.hidden = !zeigen;
  }

  /* ---------- Rahmen: Materialblick (Vorschau fährt an die Ecke, Licht streicht über die Leiste) ---------- */
  function materialBlick(){
    if (RUHIG || B.ansicht !== 'live') return;
    setTimeout(function(){
      var z = $('.lr7-live .lr9-zoom'), r = $('.lr7-live .lr7-rahmen'); if (!z || !r) return;
      var zr = z.getBoundingClientRect(), rr = r.getBoundingClientRect(); if (!rr.width) return;
      var f = 2.4, px = rr.left - zr.left + rr.width * .06, py = rr.top - zr.top + rr.height * .05;
      var ziel = 'translate(' + (zr.width * .38 - px * f).toFixed(1) + 'px,' + (zr.height * .38 - py * f).toFixed(1) + 'px) scale(' + f + ')';
      z.style.transformOrigin = '0 0';
      z.animate([{ transform: 'none' }, { transform: ziel, offset: .34 }, { transform: ziel, offset: .62 }, { transform: 'none' }], { duration: 2300, easing: 'cubic-bezier(.65,0,.35,1)' });
      r.classList.remove('lr9-glanz'); void r.offsetWidth; r.classList.add('lr9-glanz');
    }, 380);
  }

  /* ---------- Lupe ---------- */
  function lupeAuf(){
    if (!POSTER || !artwork() || $('.lr9-lupe')) return;
    var o = D.createElement('div'); o.className = 'lr9-lupe'; o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true'); o.setAttribute('aria-label', 'Poster im Detail');
    o.innerHTML = '<div class="lr9-lupe-flaeche"><div class="lr9-lupe-halt"></div></div>' +
      '<button type="button" class="lr9-lupe-zu" aria-label="Detailansicht schließen">✕</button>' +
      '<div class="lr9-lupe-leiste"><button type="button" data-z="-" aria-label="Verkleinern">−</button><span>Doppelt tippen oder mit zwei Fingern vergrößern</span><button type="button" data-z="+" aria-label="Vergrößern">+</button></div>';
    D.body.appendChild(o); D.documentElement.classList.add('lr9-lupe-offen');
    var fl = o.querySelector('.lr9-lupe-flaeche'), halt = o.querySelector('.lr9-lupe-halt');
    var fm = format(), rs = D.body.classList.contains('lr-tab-produkt') || D.body.classList.contains('lr-tab-pruefen') || B.rahmenGewaehlt;
    var au = rs ? ausfuehrung() : 'ohne';
    var m = masse(fm), L = (au === 'ohne' || au === 'leinwand') ? 0 : LEISTE, ob = m.papier.b + 2 * L, oh = m.papier.h + 2 * L;
    var W = fl.clientWidth, H = fl.clientHeight, basis = Math.min(W * .9 / ob, H * .86 / oh), z = 1, RAND = 24;
    var r = rahmenEl(au, fm, basis); r.classList.add('lr9-lupe-poster');
    var p = r.querySelector('.lr7-papier'); p.innerHTML = ''; var sv = schichtenSvg(); if (sv) p.appendChild(sv);
    halt.appendChild(r);
    function lage(){
      var pw = ob * basis * z, ph = oh * basis * z;
      var hw = Math.max(W, pw + 2 * RAND), hh = Math.max(H, ph + 2 * RAND);
      halt.style.width = hw + 'px'; halt.style.height = hh + 'px';
      r.style.width = pw + 'px'; r.style.height = ph + 'px'; if (L) r.style.borderWidth = (L * basis * z) + 'px';
      r.style.left = ((hw - pw) / 2) + 'px'; r.style.top = ((hh - ph) / 2) + 'px';
      return { pw: pw, ph: ph, ox: (hw - pw) / 2, oy: (hh - ph) / 2 };
    }
    var g = lage();
    function zoome(z2, fx, fy){
      z2 = Math.max(1, Math.min(4, z2)); if (Math.abs(z2 - z) < .01) return;
      if (fx == null) { fx = W / 2; fy = H / 2; }
      var ux = (fl.scrollLeft + fx - g.ox) / g.pw, uy = (fl.scrollTop + fy - g.oy) / g.ph;
      z = z2; g = lage();
      fl.scrollLeft = ux * g.pw + g.ox - fx; fl.scrollTop = uy * g.ph + g.oy - fy;
      if (!RUHIG) r.animate([{ opacity: .6 }, { opacity: 1 }], { duration: 260 });
    }
    /* Aufgehen: aus der Lage der Bühne heraus */
    var quelle = $('.lr7-live .lr7-rahmen');
    if (quelle && !RUHIG) {
      var a1 = quelle.getBoundingClientRect(), a2 = r.getBoundingClientRect();
      if (a1.width && a2.width) r.animate([{ transform: 'translate(' + (a1.left - a2.left) + 'px,' + (a1.top - a2.top) + 'px) scale(' + (a1.width / a2.width) + ')', transformOrigin: '0 0' }, { transform: 'none', transformOrigin: '0 0' }], { duration: 560, easing: AUS9 });
      o.animate([{ backgroundColor: 'rgba(24,22,20,0)' }, { backgroundColor: 'rgba(24,22,20,.94)' }], { duration: 400, fill: 'backwards' });
    }
    var tipp = { t: 0, x: 0, y: 0 }, finger = {}, pinch = null;
    fl.addEventListener('pointerdown', function(e){
      finger[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(finger);
      if (ids.length === 2) {
        var f1 = finger[ids[0]], f2 = finger[ids[1]], fr = fl.getBoundingClientRect();
        pinch = { d: Math.hypot(f1.x - f2.x, f1.y - f2.y), cx: (f1.x + f2.x) / 2 - fr.left, cy: (f1.y + f2.y) / 2 - fr.top, k: 1 };
      }
    });
    fl.addEventListener('pointermove', function(e){
      if (!finger[e.pointerId]) return; finger[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (!pinch) return; var ids = Object.keys(finger); if (ids.length < 2) return;
      var f1 = finger[ids[0]], f2 = finger[ids[1]];
      pinch.k = Math.max(1 / z, Math.min(4 / z, Math.hypot(f1.x - f2.x, f1.y - f2.y) / pinch.d));
      var rr = r.getBoundingClientRect(), fr = fl.getBoundingClientRect();
      r.style.transformOrigin = (pinch.cx + fr.left - rr.left) + 'px ' + (pinch.cy + fr.top - rr.top) + 'px';
      r.style.transform = 'scale(' + pinch.k.toFixed(3) + ')';
    });
    function los(e){
      delete finger[e.pointerId];
      if (pinch && Object.keys(finger).length < 2) { var k = pinch.k, cx = pinch.cx, cy = pinch.cy; pinch = null; r.style.transform = ''; r.style.transformOrigin = ''; zoome(z * k, cx, cy); tipp.t = 0; return; }
      if (e.type !== 'pointerup') return;
      var jetzt = Date.now(), fr = fl.getBoundingClientRect(), x = e.clientX - fr.left, y = e.clientY - fr.top;
      if (jetzt - tipp.t < 320 && Math.hypot(x - tipp.x, y - tipp.y) < 40) { zoome(z > 1.5 ? 1 : 2.6, x, y); tipp.t = 0; }
      else tipp = { t: jetzt, x: x, y: y };
    }
    fl.addEventListener('pointerup', los); fl.addEventListener('pointercancel', los);
    function zu(){
      D.documentElement.classList.remove('lr9-lupe-offen');
      if (RUHIG) return o.remove();
      o.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 260, fill: 'forwards' }).finished.then(function(){ o.remove(); }, function(){ o.remove(); });
    }
    o.addEventListener('click', function(e){
      if (e.target.closest('.lr9-lupe-zu')) return zu();
      var zb = e.target.closest('[data-z]'); if (zb) zoome(z * (zb.getAttribute('data-z') === '+' ? 1.6 : 1 / 1.6));
    });
    o.addEventListener('keydown', function(e){ if (e.key === 'Escape') { e.stopPropagation(); zu(); } });
    var zk = o.querySelector('.lr9-lupe-zu'); try { zk.focus({ preventScroll: true }); } catch (x) {}
  }

  /* ---------- Prüfen ---------- */
  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  function datumSchoen(v){
    var m = String(v || '').match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/); if (!m) return v;
    return (+m[3]) + '. ' + MONATE[+m[2] - 1] + ' ' + m[1] + (m[4] ? ' · ' + m[4] + ':' + m[5] + ' Uhr' : '');
  }
  function angaben(){
    var c = camp(), l = []; if (!c) return l;
    var fam = familie(), akt = fam && fam.liste.filter(function(x){ return x[0] === handle(); })[0];
    if (akt) l.push(['Design', akt[1] + ' · ' + fam.titel, 'gestalten', '']);
    var q = farbQuelle(); if (q) { var o = q.optionen.filter(function(x){ return x.wert === q.wert; })[0]; if (o) l.push([q.titel || 'Farbe', o.text, 'gestalten', '']); }
    $$('.tee-field', c).forEach(function(f){
      if (f.style.display === 'none') return;
      var n = gross(feldName(f)), lid = lidVon(f), cl = String(f.className || '');
      if (/tee-field--(template|clipart)/.test(cl)) return;
      if (/tee-field--maps/.test(cl)) { var mi = f.querySelector('.tee-field-maps'); var ot = mi ? mi.textContent.replace(/\s+/g, ' ').trim() : ''; if (ot && !/suchen|search/i.test(ot)) l.push([n || 'Ort', ot, 'gestalten', lid]); return; }
      if (/tee-field--star_maps/.test(cl)) {
        var oi = f.querySelector('input[type=text]'), zi = f.querySelector('input[type="datetime-local"]');
        if (oi && oi.value) l.push([n || 'Ort', oi.value, 'gestalten', lid]);
        if (zi && zi.value) l.push(['Datum & Uhrzeit', datumSchoen(zi.value), 'gestalten', lid]);
        return;
      }
      if (/tee-field--photo/.test(cl)) { var eigen = f.querySelector('.tee-photo-uploaded, img[src*="/uploads/"], img[src^="blob:"]'); l.push([n || 'Foto', eigen ? 'Eigenes Foto ✓' : 'Noch kein eigenes Foto – die Vorschau zeigt ein Beispiel', 'foto', lid]); return; }
      var i = f.querySelector('input.tee__input, textarea'); if (!i) return;
      var v = String(i.value || '').trim(); if (v) l.push([n || 'Text', v, 'gestalten', lid]);
    });
    var fm = format(); l.push(['Format', fm.b + ' × ' + fm.h + ' cm', 'produkt', '']);
    if (POSTER) { var au = ausfuehrung(); l.push(['Rahmen', (RAHMEN[au] || {}).name || au, 'produkt', '']); }
    return l;
  }
  function pruefPanel(){
    var halter = $('.lr-halter'); if (!halter) return;
    var box = $('.lr9-pruefen'), zeigen = S.reiter === 'pruefen' && D.body.classList.contains('lr-gestalten');
    if (!box) {
      box = D.createElement('div'); box.className = 'lr-gk-hinweis lr9-pruefen';
      var u = halter.querySelector('.lr-gk-unter'); if (!u) return; u.parentNode.insertBefore(box, u.nextSibling);
      box.addEventListener('click', function(e){
        var a = e.target.closest('[data-lr9-aendern]'); if (!a) return; e.preventDefault();
        var k = a.getAttribute('data-lr9-aendern'), lid = a.getAttribute('data-lid');
        if (!S.aktiv.some(function(x){ return x.k === k; })) k = 'gestalten';
        wechsle(k);
        if (lid) setTimeout(function(){ var f = $('.tee-campaign .tee-field--' + lid); if (!f) return; f.scrollIntoView({ block: 'center', behavior: 'smooth' }); var i = f.querySelector('input.tee__input, textarea'); if (i) setTimeout(function(){ try { i.focus({ preventScroll: true }); } catch (x) { i.focus(); } }, 420); }, 380);
      });
      box.addEventListener('change', function(e){ if (e.target.matches && e.target.matches('[data-lr9-ok]')) { siegel(e.target.checked); zeichneKopf(); } });
    }
    if (zeigen) {
      var liste = box.querySelector('.lr9-liste-halter');
      if (!liste) {
        box.innerHTML = '<div class="lr9-liste-halter"></div><label class="lr9-ok"><input type="checkbox" data-lr9-ok><span><b>Alles geprüft.</b> Genau so wird mein ' + esc(WORT) + ' gedruckt.</span></label>';
        liste = box.querySelector('.lr9-liste-halter');
      }
      var h = '<dl class="lr9-liste">' + angaben().map(function(x){ return '<div><dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd><button type="button" data-lr9-aendern="' + x[2] + '" data-lid="' + esc(x[3]) + '">Ändern</button></div>'; }).join('') + '</dl>';
      if (liste.getAttribute('data-stand') !== h) { liste.innerHTML = h; liste.setAttribute('data-stand', h); }
      var zu = $('.lr8-zusatz'); if (zu && zu.parentNode !== box) box.appendChild(zu);
    }
    box.hidden = !zeigen;
  }
  function bestaetigt(){ var ok = $('[data-lr9-ok]'); return !!(ok && ok.checked); }
  function siegel(an){
    var b = buehne && buehne.querySelector('.lr7-bild'), s = $('.lr9-siegel');
    if (!an) { if (s) s.remove(); return; }
    if (!b || s) return;
    s = D.createElement('div'); s.className = 'lr9-siegel'; s.setAttribute('aria-hidden', 'true'); s.innerHTML = '<span>Geprüft</span><b>✓</b>';
    b.appendChild(s);
    if (!RUHIG) s.animate([{ transform: 'scale(1.9) rotate(-28deg)', opacity: 0 }, { opacity: 1, offset: .4 }, { transform: 'scale(1) rotate(-9deg)', opacity: 1 }], { duration: 620, easing: FEDER9, fill: 'backwards' });
  }

  /* ---------- Schrittwechsel: Inhalt steigt federnd herein ---------- */
  function schrittUebergang(zurueck){
    if (RUHIG) return;
    var h = $('.lr-halter'); if (!h) return;
    var kinder = [].filter.call(h.children, function(e){ return !e.hidden && e.getClientRects().length && !e.classList.contains('tee-campaign-wrapper-leer'); });
    var felder = $$('.tee-campaign .tee-field:not(.lr-weg)').filter(function(e){ return e.getClientRects().length; }).slice(0, 6);
    var alle = [];
    kinder.forEach(function(e){ if (e.querySelector && e.querySelector('.tee-campaign') && felder.length) alle = alle.concat(felder); else alle.push(e); });
    alle.slice(0, 10).forEach(function(e, n){
      e.animate([{ opacity: 0, transform: 'translateY(' + (zurueck ? -16 : 28) + 'px) scale(.985)' }, { opacity: 1, transform: 'none' }], { duration: 640, delay: 40 + n * 55, easing: FEDER9, fill: 'backwards' });
    });
  }

  /* ---------- Film: „Dein Poster in Szene“ ---------- */
  var F = null;
  function ladeBild(u){
    return new Promise(function(ok){
      if (!u) return ok();
      var i = new Image(), fertig = false, einmal = function(){ if (fertig) return; fertig = true; ok(); };
      i.onload = function(){ (i.decode ? i.decode() : Promise.resolve()).then(einmal, einmal); };
      i.onerror = einmal; i.src = u; setTimeout(einmal, 6000);
    });
  }
  function filmAnim(el, kf, opt){
    if (!F || !el) return null;
    var a = el.animate(kf, Object.assign({ fill: 'forwards', easing: AUS9 }, opt));
    F.anims.push(a); if (F.pause) a.pause(); return a;
  }
  function filmWarte(ms, fertig){
    var rest = ms, zuletzt = performance.now(), id = F.id = (F.id || 0) + 1;
    (function tick(t){
      if (!F || F.id !== id) return;
      var dt = Math.min(64, t - zuletzt); zuletzt = t;
      if (!F.pause) { rest -= dt; if (F.drehen && drehEl) { B.winkel += dt * .075; if (B.winkel > 180) B.winkel -= 360; stelle(); } }
      if (rest <= 0) return fertig();
      requestAnimationFrame(tick);
    })(zuletzt);
  }
  function filmStart(){
    if (!POSTER || F) return;
    var b = bauen(); if (!b) return;
    textZoom(null);
    D.body.classList.add('lr9-film-an');
    var box = D.createElement('div'); box.className = 'lr9-film';
    box.innerHTML = '<div class="lr9-film-buehne"></div>' +
      '<div class="lr9-film-lade"><div class="lr9-film-lade-poster"></div><p class="lr9-film-lade-titel">Wir setzen dein ' + esc(WORT) + ' in Szene</p>' +
      '<i class="lr9-film-linie"><b></b></i><ul class="lr9-film-schritte"><li>Papier und Farben</li><li>Rahmen anpassen</li><li>Licht setzen</li><li>Räume einrichten</li></ul></div>' +
      '<div class="lr9-film-balken" aria-hidden="true"></div><p class="lr9-film-text" aria-live="polite"><span></span></p>' +
      '<button type="button" class="lr9-film-weg">Überspringen</button>';
    b.appendChild(box);
    F = { box: box, anims: [], pause: false, shots: [], nr: -1 };
    box.addEventListener('click', function(e){
      if (e.target.closest('.lr9-film-weg')) { e.stopPropagation(); return filmEnde(true); }
      if (e.target.closest('[data-lr9-nochmal]')) { e.stopPropagation(); filmStopp(); return filmStart(); }
      if (!F || F.fertig || e.target.closest('button')) return;
      F.pause = !F.pause; box.classList.toggle('lr9-steht', F.pause);
      F.anims.forEach(function(a){ try { F.pause ? a.pause() : a.play(); } catch (x) {} });
    });
    setTimeout(function(){ if (F && F.box === box) filmAufbau(); }, 420);
  }
  function filmAufbau(){
    var box = F.box, st = { w: box.clientWidth || 360, h: box.clientHeight || 480 }; F.st = st;
    var fm = format(), au = ausfuehrung(); F.fm = fm; F.au = au;
    var lp = box.querySelector('.lr9-film-lade-poster');
    var m = masse(fm), L = (au === 'ohne' || au === 'leinwand') ? 0 : LEISTE, ob = m.papier.b + 2 * L, oh = m.papier.h + 2 * L;
    var ppc = Math.min(st.w * .46 / ob, st.h * .44 / oh);
    var r = rahmenEl(au, fm, ppc); r.style.position = 'relative'; r.style.transform = 'none';
    var p = r.querySelector('.lr7-papier'); p.innerHTML = ''; var sv = schichtenSvg(); if (sv) p.appendChild(sv);
    lp.appendChild(r);
    if (!RUHIG) {
      filmAnim(r, [{ transform: 'translateY(16px) scale(.94)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 800 });
      filmAnim(box.querySelector('.lr9-film-linie b'), [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: 3000, easing: 'cubic-bezier(.5,0,.3,1)' });
      $$('.lr9-film-schritte li', box).forEach(function(li, i){ filmAnim(li, [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 500, delay: 250 + i * 650, fill: 'both' }); });
    }
    var urls = [BILD.korn, BILD['r_' + au], BILD['k_' + au], BILD['kh_' + au], BILD.rueckwand];
    ['wand', 'geschenk', 'nah', 'boden'].forEach(function(k){ var Z = SZENEN[k]; if (!Z) return; urls.push(bildFuer(Z, Math.min(st.w, st.h) * (Z.zoom || 1)), Z.licht, Z.glanz); });
    var t0 = Date.now(), box0 = box;
    Promise.all(urls.filter(Boolean).map(ladeBild)).then(function(){
      setTimeout(function(){ if (F && F.box === box0) filmLos(); }, Math.max(0, 3100 - (Date.now() - t0)));
    });
  }
  var SCHNITTE9 = [
    function(neu, alt){ return [[neu, [{ clipPath: 'circle(0% at 50% 50%)' }, { clipPath: 'circle(75% at 50% 50%)' }]], [alt, [{ transform: 'none' }, { transform: 'scale(1.12)' }]]]; },
    function(neu, alt){ return [[neu, [{ clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0 0 0 0)' }]], [alt, [{ transform: 'none' }, { transform: 'translateY(-9%)' }]]]; },
    function(neu, alt){ return [[neu, [{ clipPath: 'inset(0 0 0 100%)' }, { clipPath: 'inset(0 0 0 0)' }]], [alt, [{ transform: 'none' }, { transform: 'translateX(-11%)' }]]]; },
    function(neu, alt){ return [[neu, [{ opacity: 0, transform: 'scale(1.2)' }, { opacity: 1, transform: 'none' }]], [alt, [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.9)' }]]]; },
    function(neu, alt){ return [[neu, [{ clipPath: 'inset(0 50% 0 50%)' }, { clipPath: 'inset(0 0 0 0)' }]], [alt, [{ transform: 'none', opacity: 1 }, { transform: 'scale(.95)', opacity: .4 }]]]; }
  ];
  function filmDetail(fm, au, st){
    var w = D.createElement('div'); w.className = 'lr9-detail';
    var m = masse(fm), L = (au === 'ohne' || au === 'leinwand') ? 0 : LEISTE, ob = m.papier.b + 2 * L, oh = m.papier.h + 2 * L;
    var ppc = Math.max(st.w * 1.75 / ob, st.h * 1.3 / oh);
    var r = rahmenEl(au, fm, ppc); r.style.transform = 'none';
    var p = r.querySelector('.lr7-papier'); p.innerHTML = ''; var sv = schichtenSvg(); if (sv) p.appendChild(sv);
    w.appendChild(r); w._r = r; w._gr = { w: ob * ppc, h: oh * ppc };
    return w;
  }
  function filmLos(){
    var box = F.box, st = F.st, fm = F.fm, au = F.au, bue = box.querySelector('.lr9-film-buehne');
    var shots = [
      { k: 'detail', d: 3000, t: 'Jedes Detail – gestochen scharf' },
      { k: 'wand', d: 2800, t: 'Über dem Sofa – in echter Größe' },
      { k: 'geschenk', d: 2400, t: 'Als Geschenk' },
      { k: 'nah', d: 2400, t: 'Aus der Nähe' },
      { k: 'boden', d: 2400, t: 'Angelehnt, ganz entspannt' },
      { k: 'dreh', d: 3400, t: 'Rundum sauber verarbeitet' }
    ].filter(function(s){ return s.k === 'detail' || s.k === 'dreh' || SZENEN[s.k]; });
    var vorher = B.ansicht;
    shots.forEach(function(s){
      var el;
      try {
        if (s.k === 'detail') el = filmDetail(fm, au, st);
        else if (s.k === 'dreh') { el = dreh(fm, au, st); el.style.pointerEvents = 'none'; }
        else { B.ansicht = s.k; el = szene(SZENEN[s.k], fm, au, st); B.ansicht = vorher; }
      } catch (x) { el = null; }
      if (!el) return;
      var h = D.createElement('div'); h.className = 'lr9-shot'; h.appendChild(el); bue.appendChild(h); s.el = h;
    });
    F.shots = shots.filter(function(s){ return s.el; });
    box.querySelector('.lr9-film-balken').innerHTML = F.shots.map(function(){ return '<i><b></b></i>'; }).join('');
    var lade = box.querySelector('.lr9-film-lade');
    filmAnim(lade, [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(1.06)' }], { duration: 600 });
    setTimeout(function(){ if (lade) lade.style.visibility = 'hidden'; }, 650);
    box.classList.add('lr9-laeuft');
    filmShot(0);
  }
  function filmShot(n){
    if (!F) return;
    var s = F.shots[n], alt = F.shots[n - 1];
    F.nr = n; F.drehen = false;
    if (!s) return filmEnde(false);
    s.el.classList.add('an');
    if (alt) {
      SCHNITTE9[(n - 1) % SCHNITTE9.length](s.el, alt.el).forEach(function(x){ filmAnim(x[0], x[1], { duration: 950, easing: WISCH9 }); });
      setTimeout(function(){ if (alt.el) alt.el.classList.remove('an'); }, 1000);
    } else filmAnim(s.el, [{ opacity: 0 }, { opacity: 1 }], { duration: 700 });
    var inn = s.el.firstChild;
    if (s.k === 'detail') {
      var g = inn._gr, st = F.st, dx = Math.max(0, g.w - st.w), dy = Math.max(0, g.h - st.h);
      filmAnim(inn._r, [{ transform: 'translate(' + (-dx * .1).toFixed(0) + 'px,' + (-dy * .05).toFixed(0) + 'px)' }, { transform: 'translate(' + (-dx * .5).toFixed(0) + 'px,' + (-dy * .93).toFixed(0) + 'px)' }], { duration: s.d + 950, easing: 'cubic-bezier(.45,0,.3,1)' });
    } else if (s.k === 'dreh') { drehEl = inn; B.winkel = -55; B.kipp = -7; stelle(); F.drehen = true; }
    else filmAnim(inn, [{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }], { duration: s.d + 950, easing: 'linear' });
    var tx = F.box.querySelector('.lr9-film-text span'); tx.textContent = s.t;
    filmAnim(tx, [{ transform: 'translateY(110%)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 700, delay: 260 });
    var bal = F.box.querySelectorAll('.lr9-film-balken b');
    [].forEach.call(bal, function(x, i){ if (i < n) x.style.transform = 'scaleX(1)'; });
    if (bal[n]) filmAnim(bal[n], [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: s.d, easing: 'linear' });
    filmWarte(s.d, function(){ filmShot(n + 1); });
  }
  function filmEnde(gesprungen){
    if (!F || F.fertig) return;
    F.fertig = true; F.id = -1; F.drehen = false; F.pause = false;
    var box = F.box; box.classList.remove('lr9-steht');
    if (gesprungen) F.anims.forEach(function(a){ try { a.finish(); } catch (x) {} });
    var lade = box.querySelector('.lr9-film-lade'); if (lade) lade.style.visibility = 'hidden';
    var sch = D.createElement('div'); sch.className = 'lr9-film-schluss';
    var st = F.st || { w: box.clientWidth, h: box.clientHeight }, fm = F.fm || format(), au = F.au || ausfuehrung();
    var m = masse(fm), L = (au === 'ohne' || au === 'leinwand') ? 0 : LEISTE, ob = m.papier.b + 2 * L, oh = m.papier.h + 2 * L;
    var r = rahmenEl(au, fm, Math.min(st.w * .62 / ob, st.h * .6 / oh)); r.style.position = 'relative'; r.style.transform = 'none';
    var p = r.querySelector('.lr7-papier'); p.innerHTML = ''; var sv = schichtenSvg(); if (sv) p.appendChild(sv);
    sch.innerHTML = '<div class="lr9-film-schluss-poster"></div><p><b>So kommt es bei dir an.</b><span>Jetzt nur noch prüfen – dann ist es deins.</span></p><button type="button" data-lr9-nochmal>Nochmal ansehen</button>';
    sch.querySelector('.lr9-film-schluss-poster').appendChild(r);
    box.appendChild(sch);
    $$('.lr9-film-balken b', box).forEach(function(x){ x.style.transform = 'scaleX(1)'; });
    var weg = box.querySelector('.lr9-film-weg'); if (weg) weg.hidden = true;
    var tx = box.querySelector('.lr9-film-text'); if (tx) tx.style.visibility = 'hidden';
    if (!RUHIG) {
      sch.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 600, fill: 'backwards' });
      r.animate([{ transform: 'translateY(22px) scale(.92)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 900, easing: FEDER9, fill: 'backwards', delay: 120 });
    }
    var w = $('[data-lr-weiter]'); if (w) { w.classList.remove('lr9-winkt'); void w.offsetWidth; w.classList.add('lr9-winkt'); }
  }
  function filmStopp(){
    if (!F) return;
    F.id = -1; F.anims.forEach(function(a){ try { a.cancel(); } catch (x) {} });
    if (F.box && F.box.parentNode) F.box.parentNode.removeChild(F.box);
    F = null; drehEl = null;
    D.body.classList.remove('lr9-film-an');
    var w = $('[data-lr-weiter]'); if (w) w.classList.remove('lr9-winkt');
    setTimeout(function(){ B.zeichne(true); }, 360);
  }

  /* ================= Takt: alles pflegen (gedrosselt) ================= */
  function arbeite(sofort){
    var c = camp(); if (!c) return;
    baueSeite(c); ordne(c); zeichneKopf(); tabKlasse();
    pflegePreise(); try { titelPflegen(c); } catch (e) {}
    if (D.body.classList.contains('lr-gestalten')) { designPanel(); produktPanel(); farbPanel(); groessenPanel(); pruefPanel(); B.zeichne(); try { vorlageHalten(); sternZeitPruefen(); kartenOrtPruefen(); sternBeobachten(); } catch (e) {} }
  }
  var warte = false, uebersetzt = 0;
  function takt(){
    if (warte) return; warte = true;
    setTimeout(function(){
      warte = false;
      try {
        karteHaken();
        var c = camp();
        if (c && Date.now() - uebersetzt > 600) { uebersetzt = Date.now(); uebersetze(c); uebersetzeDialoge(); }
        else { clearTimeout(B.tU); B.tU = setTimeout(function(){ uebersetzt = Date.now(); var c2 = camp(); if (c2) uebersetze(c2); uebersetzeDialoge(); }, 650); }
        arbeite();
      } catch (e) { if (window.console) console.warn('lr7', e); }
    }, 180);
  }
  /* EIN Beobachter: nur Knoten-Änderungen im Produktbereich, keine Zeichen-/Attribut-Flut */
  var mo = new MutationObserver(function(liste){
    for (var i = 0; i < liste.length; i++) { var t = liste[i].target; if (t.closest && t.closest('.lr7, .lr7-designs, .lr7-rahmenwahl, .lr-gk, .lr9-farben, .lr9-groessen, .lr9-pruefen, .lr9-lupe')) continue; return takt(); }
  });
  function start(){
    var ziel = $('.product-information') || D.body;
    mo.observe(ziel, { childList: true, subtree: true });
    arbeite(); ladePreise(); setTimeout(function(){ kampagne(); }, 1500);
    /* Größe / Ausführung / Vorlage geändert */
    D.addEventListener('change', function(e){
      if (!e.target.closest) return;
      if (e.target.type === 'file') { [700, 1600, 3200].forEach(function(t){ setTimeout(uebersetzeDialoge, t); }); }
      if (e.target.closest('.tee-campaign')) { takt(); setTimeout(function(){ pflegePreise(); B.zeichne(true); designPanel(); }, 250); }
    }, true);
    D.addEventListener('click', function(e){
      if (!e.target.closest) return;
      if (e.target.closest('.tee-option--size .tee-radio')) {
        /* Die gewaehlte Ansicht bleibt stehen. Frueher sprang die Live-Vorschau beim
           Groessenwechsel ungefragt auf die Wandansicht – genau das soll nicht passieren. */
        setTimeout(function(){ pflegePreise(); B.zeichne(true); }, 260);
      }
    }, true);
    /* Gestalter 9: Vorschau bleibt groß (Lucas Punkt 4) – nur beim Tippen macht sie der Tastatur Platz */
    if (false) {
      var klein = false, ws = false;
      D.addEventListener('scroll', function(e){
        var k = e.target; if (!k || !k.classList || !k.classList.contains('lr-kette') || ws) return;
        ws = true; requestAnimationFrame(function(){ ws = false; var y = k.scrollTop; var soll = klein ? y > 4 : y > 110; if (soll !== klein) { klein = soll; D.body.classList.toggle('lr-vorschau-klein', klein); setTimeout(function(){ B.zeichne(true); }, 320); } });
      }, { capture: true, passive: true });
    }
    addEventListener('resize', function(){ clearTimeout(window.__lr7r); window.__lr7r = setTimeout(function(){ B.zeichne(true); }, 150); }, { passive: true });
    /* Einstieg */
    var hash = location.hash;
    if (hash === '#gestalten' || hash === '#gestalten-design') {
      B.designAnkunft = hash === '#gestalten-design';
      try { var an = +sessionStorage.getItem('lr9-ankunft') || 0; if (an && Date.now() - an < 30000) B.designAnkunft = true; sessionStorage.removeItem('lr9-ankunft'); } catch (x) {}
      var n = 0, t = setInterval(function(){ n++; if (camp() && $('.tee-campaign .tee-field')) { clearInterval(t); arbeite(); oeffnen(hash === '#gestalten-design' ? 'gestalten' : null); if (hash === '#gestalten-design') history.replaceState({ lr: 1 }, '', location.pathname + location.search + '#gestalten'); } else if (n > 40) clearInterval(t); }, 300);
    }
    uebernehmen();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
  window.LR7 = { zeige: zeige, B: B, S: S, dbg: { angaben: angaben, farbQuelle: farbQuelle, wechsle: wechsle, vorlageWahl: vorlageWahl } };
})();

/* ============================================================================
   Farben vorwärmen (24.09.2026)
   Beim ersten Klick auf eine andere Kartenfarbe lädt teeinblue drei Dinge neu:
   Papier, Gestaltungsebene und das Mapbox-Bild im neuen Stil. Genau das dauert.
   Die Kampagnendaten mit ALLEN sechs Vorlagen liegen bereits im Browser – wir
   lesen sie aus dem Cache und holen die fehlenden Bilder still im Hintergrund.
   Kein zusätzlicher Datenverkehr für teeinblue, nur ein früherer Zeitpunkt.
   ========================================================================== */
(function(){
  var geholt = {}, karteZuletzt = '';
  function hol(u){ if (!u || geholt[u]) return; geholt[u] = 1; var i = new Image(); i.decoding = 'async'; i.src = u; }
  function mittel(fn){ ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 1200); }

  /* Die zuletzt gezeichnete Mapbox-Kachel als Muster – daraus bauen wir die
     fünf Geschwister, indem nur die Stil-Kennung ersetzt wird. Mitte, Zoom,
     Größe und Zugangsschlüssel bleiben unverändert. */
  function karteMuster(){
    var l = performance.getEntriesByType('resource').map(function(r){ return r.name; })
      .filter(function(n){ return /api\.mapbox\.com\/styles\/v1\/[^/]+\/[^/]+\/static\//.test(n); });
    return l.length ? l[l.length - 1] : '';
  }
  function karteFuer(muster, stil){
    var s = String(stil || '').replace('mapbox://styles/', '');
    if (!muster || !s) return '';
    return muster.replace(/styles\/v1\/[^/]+\/[^/]+\/static\//, 'styles/v1/' + s + '/static/');
  }

  function warm(){
    var q = performance.getEntriesByType('resource').map(function(r){ return r.name; })
      .filter(function(n){ return /merchant\/campaigns\/.*\.json/.test(n); })[0];
    if (!q) return;
    var muster = karteMuster();
    if (!muster || muster === karteZuletzt) { if (!muster) return; }
    karteZuletzt = muster;
    fetch(q, { credentials: 'omit' }).then(function(r){ return r.json(); }).then(function(j){
      (j.artworks || []).forEach(function(a){
        (a.data || []).forEach(function(t){
          (t.layers || []).forEach(function(l){
            if (l.type === 'static-photo' && l.url && l.url.indexOf('placehold') < 0)
              hol('https://cdn.teeinblue.com/' + l.url + '?v=1');
            if (l.type === 'maps' && l.maps_default_style)
              hol(karteFuer(muster, l.maps_default_style));
          });
        });
      });
    }).catch(function(){});
  }

  /* Einmal kurz nach dem ersten Zeichnen – und noch einmal, wenn der Kunde
     seinen Ort geändert hat, weil dann alle sechs Kartenbilder neu sind. */
  var t = null;
  function spaeter(){ clearTimeout(t); t = setTimeout(function(){ mittel(warm); }, 1400); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', spaeter); else spaeter();
  var beob = new MutationObserver(function(){ if (karteMuster() !== karteZuletzt) spaeter(); });
  try { beob.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['src', 'href', 'xlink:href'] }); } catch (e) {}
})();

/* ============================================================================
   Quellenangabe für das Kartenmaterial (OpenStreetMap / Microsoft)
   ========================================================================== */
(function(){
  var TEXT = '© OpenStreetMap Contributors · Gebäudedaten: Microsoft Building Footprints';
  function setzen(){
    var b = document.querySelector('.lr7-buehne, .lr7-unten');
    if (!b || document.querySelector('.lr7-quelle')) return;
    var p = document.createElement('p'); p.className = 'lr7-quelle'; p.textContent = TEXT;
    b.appendChild(p);
  }
  var n = 0, iv = setInterval(function(){ setzen(); if (++n > 40 || document.querySelector('.lr7-quelle')) clearInterval(iv); }, 500);
})();


/* ============================================================================
   Karten-Zoom: beim Auswaehlen eines Ortes die GANZE Stadt zeigen (24.09.2026)
   teeinblue rechnet ueber fitBounds zuerst den richtigen Stadtausschnitt aus und
   ueberschreibt ihn unmittelbar danach mit einem festen Zoom 15 – dann sieht man
   nur noch ein paar Strassen. Wir lassen das Ergebnis von fitBounds stehen und
   halten nachfolgende Zwangs-Zooms 1,5 s lang ab. Der Kunde kann danach jederzeit
   selbst mit + und - naeher ran oder weiter raus.
   ========================================================================== */
(function(){
  var NAH = 13, WEIT = 11;             /* 28.09.2026 Luca: Vorschau muss wie das Produktbild aussehen, unter 11 werden Strassen duenn/dunkel */              /* Fenster fuer "ganze Stadt" */
  var ziel = null, bis = 0, eigen = false;
  function klemme(z){ return Math.max(WEIT, Math.min(NAH, z)); }
  function haken(){
    var L = window.L;
    if (!L || !L.Map || !L.Map.prototype || L.Map.prototype.__lrStadtzoom) return !!(L && L.Map && L.Map.prototype && L.Map.prototype.__lrStadtzoom);
    var P = L.Map.prototype; P.__lrStadtzoom = 1;
    var fb = P.fitBounds;
    P.fitBounds = function(){
      bis = 0;
      var r = fb.apply(this, arguments);
      try {
        ziel = klemme(this.getZoom()); bis = Date.now() + 1500;
        if (this.getZoom() !== ziel) { eigen = true; this.setZoom(ziel, { animate: false }); eigen = false; }
      } catch (e) {}
      return r;
    };
    ['setZoom', 'setView'].forEach(function(n){
      var o = P[n];
      P[n] = function(){
        if (!eigen && ziel != null && Date.now() < bis) {
          var a = [].slice.call(arguments);
          if (n === 'setZoom') a[0] = ziel; else if (a.length > 1 && typeof a[1] === 'number') a[1] = ziel;
          return o.apply(this, a);
        }
        return o.apply(this, arguments);
      };
    });
    return true;
  }
  if (!haken()) { var n = 0, iv = setInterval(function(){ if (haken() || ++n > 150) clearInterval(iv); }, 300); }
})();

/* ================= Markierung (Pinnadel/Herz) auf dem Handy (28.09.2026) =================
   1) iPhone: teeinblue zeigt beim Berühren einer Kachel erst ein Namens-Schild (Hover). Safari
      wertet den ersten Tipp dann nur als Hover – die Auswahl passiert erst beim zweiten Tipp.
      Ein kurzer Tipp ohne Bewegung wählt die Kachel deshalb direkt aus (label.click, wie ein Nutzer).
   2) Kartendialog: gewählte Markierung fest in der Kartenmitte einblenden. Sie steht genau dort,
      wo sie auf dem Poster landet (Markierungs-Ebene = Kartenmitte). Karte darunter verschieben
      = Nadel verschieben. */
(function(){
  'use strict';
  var D = document, start = null;
  D.addEventListener('touchstart', function(e){
    var l = e.target.closest && e.target.closest('.tee-clipart-label');
    start = (l && e.touches.length === 1) ? { l: l, x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() } : null;
  }, { passive: true, capture: true });
  D.addEventListener('touchend', function(e){
    var s = start; start = null; if (!s) return;
    var p = e.changedTouches && e.changedTouches[0];
    if (!p || Math.abs(p.clientX - s.x) > 10 || Math.abs(p.clientY - s.y) > 10 || Date.now() - s.t > 700) return;
    var l = e.target.closest && e.target.closest('.tee-clipart-label'); if (l !== s.l) return;
    var inp = D.getElementById(l.htmlFor); if (inp && inp.checked) return;
    e.preventDefault(); l.click();
  }, { passive: false, capture: true });

  function markierung(){
    var f = [].filter.call(D.querySelectorAll('.tee-form-wrapper .tee-field'), function(x){
      var k = x.querySelector('.tee-field__label, label:not(.tee-clipart-label), legend');
      return /Markierung/.test(k ? k.textContent : x.textContent.slice(0, 40)) && x.querySelector('.tee-clipart-label');
    })[0];
    if (!f) return null;
    var r = [].filter.call(f.querySelectorAll('input'), function(i){ return i.checked; })[0];
    var l = r && f.querySelector('label[for="' + r.id + '"]');
    if (!l || /^keine$/i.test(l.getAttribute('data-title') || '')) return null;
    var img = l.querySelector('img'), src = img && (img.getAttribute('src') || img.getAttribute('data-src')) || '';
    return { name: l.getAttribute('data-title'), src: src, gross: src.replace('_thumbnail.webp', '.svg') };
  }
  function einblenden(dlg){
    var box = dlg.querySelector('.leaflet-container'); if (!box) return false;
    var m = markierung(), alt = box.querySelector('.lr-pin');
    if (!m) { if (alt) alt.remove(); return true; }
    if (alt && alt.getAttribute('data-n') === m.name) return true;
    if (alt) alt.remove();
    var d = D.createElement('div'); d.className = 'lr-pin'; d.setAttribute('data-n', m.name);
    d.innerHTML = '<img alt="" src="' + m.gross + '"><span>Karte verschieben, bis die ' + (/herz/i.test(m.name) ? 'Markierung' : 'Nadel') + ' richtig sitzt</span>';
    var i = d.querySelector('img'); i.onerror = function(){ i.onerror = null; i.src = m.src; };
    box.appendChild(d);
    return true;
  }
  function suchen(n){
    var dlg = D.querySelector('.vm--container.tee-dialog-maps');
    if (dlg && einblenden(dlg)) return;
    if (n < 25) setTimeout(function(){ suchen(n + 1); }, 200);
  }
  D.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('.tee-field-maps')) setTimeout(function(){ suchen(0); }, 150);
  }, true);

  /* Ortssuche: teeinblue setzt die Karte auf die Mitte des Treffer-RAHMENS (bbox). Bei Hamburg reicht der
     Rahmen bis Neuwerk -> Nadel im Umland. Treffer mitschneiden und die Rahmenmitte auf 'center' umlenken
     (übernommen aus lr-nadel.js, Gehirn #2849). */
  var treffer = [];
  function merke(url, txt){
    if (!/\/maps\/places\//.test(url)) return;
    try { (JSON.parse(txt).features || []).forEach(function(f){ if (f.bbox && f.center) treffer.push(f); }); treffer = treffer.slice(-40); } catch (e) {}
  }
  var ofetch = window.fetch;
  if (ofetch) window.fetch = function(u){
    var p = ofetch.apply(this, arguments), url = String(u && u.url || u);
    if (/\/maps\/places\//.test(url)) p.then(function(r){ r.clone().text().then(function(t){ merke(url, t); }); }).catch(function(){});
    return p;
  };
  var oopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){
    var x = this; if (/\/maps\/places\//.test(String(u))) x.addEventListener('load', function(){ merke(String(u), x.responseText); });
    return oopen.apply(this, arguments);
  };
  function mitteHaken(){
    var L = window.L; if (!L || !L.Map || !L.Map.prototype) return false;
    var P = L.Map.prototype; if (P.__lrMitte) return true; P.__lrMitte = 1;
    var fb = P.fitBounds, sv = P.setView, offen = null;
    P.fitBounds = function(b){
      try {
        var bb = L.latLngBounds(b), nah = function(a, c){ return Math.abs(a - c) < 1e-3; };
        var f = treffer.filter(function(f){ return nah(f.bbox[0], bb.getWest()) && nah(f.bbox[1], bb.getSouth()) && nah(f.bbox[2], bb.getEast()) && nah(f.bbox[3], bb.getNorth()); }).pop();
        offen = f ? { m: bb.getCenter(), c: L.latLng(f.center[1], f.center[0]), bis: Date.now() + 5000 } : null;
      } catch (e) { offen = null; }
      var r = fb.apply(this, arguments);
      if (offen) { try { sv.call(this, offen.c, this.getZoom(), { animate: false }); } catch (e) {} }
      return r;
    };
    P.setView = function(c){
      if (offen && Date.now() < offen.bis) {
        try {
          var ll = L.latLng(c);
          if (Math.abs(ll.lat - offen.m.lat) < 0.02 && Math.abs(ll.lng - offen.m.lng) < 0.04) { var a = [].slice.call(arguments); a[0] = offen.c; return sv.apply(this, a); }
        } catch (e) {}
      }
      return sv.apply(this, arguments);
    };
    return true;
  }
  if (!mitteHaken()) { var mh = 0, mi = setInterval(function(){ if (mitteHaken() || ++mh > 150) clearInterval(mi); }, 200); }
  var st = D.createElement('style');
  st.textContent = '.lr-pin{position:absolute;inset:0;z-index:650;pointer-events:none}' +
    '.lr-pin img{position:absolute;left:50%;top:50%;transform:translate(-50%,-100%);width:44px;height:44px;object-fit:contain;object-position:50% 100%;filter:drop-shadow(0 1px 2px rgba(0,0,0,.45)) drop-shadow(0 0 1px #fff)}' +
    '.lr-pin span{position:absolute;left:50%;bottom:12px;transform:translateX(-50%);background:rgba(23,23,23,.82);color:#fff;font:500 13px/1.3 Jost,Arial,sans-serif;padding:6px 12px;border-radius:999px;white-space:nowrap;max-width:92%;overflow:hidden;text-overflow:ellipsis}';
  D.head.appendChild(st);
})();
